import { e as ee$2, R as R$1, c as ce$1, f as fe$2, t as te$1, E as E$2, u as u$1, _ as _e$1, L, j as j$2, x as xe$1, W as W$2, B, g as ge$2, v as v$2, i as ie$2, a as fa, C as C$2, S as Sa, T as Ti$1, s as sa$1, h as he$1, m as ma, b as La$1, V as V$1, d as ta$1, A as Aa$1, k as cs$1, l as Ca, w as wa$1, I as I$1, n as Se$2, D, O as O$1, N as N$1, o as Oa$1, p as x$3, q as b$2, r as h$2, y as de$2 } from './index.esm-72008b43.js';
import { _ as _baseAssignValue, e as eq_1, k as keys_1, i as isObject_1, a as _isPrototype, b as _arrayLikeKeys, c as isArrayLike_1, d as _root, f as _getSymbols, g as _overArg, h as _arrayPush, s as stubArray_1, j as _baseGetAllKeys, l as _Uint8Array, m as _Symbol, n as _getTag, o as isObjectLike_1, p as _baseUnary, q as _nodeUtil, r as _Stack, t as isBuffer$1, u as _getAllKeys, v as isArray_1, X as Xn$1, Z as Zt$1, R as Rt$1, C as C$1, w as nr$1, x as k, y as x$2, z as or$1, A as y, H as Ht, T as Tt$1, B as ht$1, D as Ze$2, E as Xe$2, I as Ii$1, F as et$2, G as R$2, J as hn$1, K as yn$1, L as wn$1, M as lodash, N as Kn$1, O as pi$1, P as lr$1, Q as ti, S as zo, U as ei$1, V as Ho$1, W as fn$1, Y as dn$1, $ as ee$3, a0 as Zn, a1 as Yt, a2 as ni, a3 as Xt$1, a4 as He$1, a5 as $t } from './index.esm-3fd4a3f5.js';

// src/utils/formatProdErrorMessage.ts
function formatProdErrorMessage$1(code) {
  return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;

// src/utils/actionTypes.ts
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${ randomString()}`,
  REPLACE: `@@redux/REPLACE${ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;

// src/utils/isPlainObject.ts
function isPlainObject$1(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}

// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(formatProdErrorMessage$1(2) );
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(formatProdErrorMessage$1(0) );
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(formatProdErrorMessage$1(1) );
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(3) );
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(formatProdErrorMessage$1(4) );
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(5) );
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(formatProdErrorMessage$1(6) );
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$1(action)) {
      throw new Error(formatProdErrorMessage$1(7) );
    }
    if (typeof action.type === "undefined") {
      throw new Error(formatProdErrorMessage$1(8) );
    }
    if (typeof action.type !== "string") {
      throw new Error(formatProdErrorMessage$1(17) );
    }
    if (isDispatching) {
      throw new Error(formatProdErrorMessage$1(9) );
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(formatProdErrorMessage$1(10) );
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(formatProdErrorMessage$1(11) );
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store = {
    dispatch,
    subscribe,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store;
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState === "undefined") {
      throw new Error(formatProdErrorMessage$1(12) );
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(formatProdErrorMessage$1(13) );
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i = 0; i < reducerKeys.length; i++) {
    const key = reducerKeys[i];
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    let hasChanged = false;
    const nextState = {};
    for (let i = 0; i < finalReducerKeys.length; i++) {
      const key = finalReducerKeys[i];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        throw new Error(formatProdErrorMessage$1(14) );
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

// src/compose.ts
function compose(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(formatProdErrorMessage$1(15) );
    };
    const middlewareAPI = {
      getState: store.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose(...chain)(store.dispatch);
    return {
      ...store,
      dispatch
    };
  };
}

// src/utils/isAction.ts
function isAction(action) {
  return isPlainObject$1(action) && "type" in action && typeof action.type === "string";
}

// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
function die(error, ...args) {
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}

// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap$2(value) || isSet$2(value);
}
var objectCtorString = Object.prototype.constructor.toString();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null) {
    return true;
  }
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  return typeof Ctor == "function" && Function.toString.call(Ctor) === objectCtorString;
}
function each(obj, iter) {
  if (getArchtype(obj) === 0 /* Object */) {
    Reflect.ownKeys(obj).forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */ : isMap$2(thing) ? 2 /* Map */ : isSet$2(thing) ? 3 /* Set */ : 0 /* Object */;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 /* Map */ ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2 /* Map */)
    thing.set(propOrOldValue, value);
  else if (t === 3 /* Set */) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is$1(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap$2(target) {
  return target instanceof Map;
}
function isSet$2(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap$2(base)) {
    return new Map(base);
  }
  if (isSet$2(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    obj.set = obj.add = obj.clear = obj.delete = dontMutateFrozenCollections;
  }
  Object.freeze(obj);
  if (deep)
    Object.entries(obj).forEach(([key, value]) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
function isFrozen(obj) {
  return Object.isFrozen(obj);
}

// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}

// src/core/scope.ts
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 /* Object */ || state.type_ === 1 /* Array */)
    state.revoke_();
  else
    state.revoked_ = true;
}

// src/core/finalize.ts
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path)
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3 /* Set */) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(rootScope, state, result, key, childValue, path, isSet2)
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 /* Set */ && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !isFrozen(childValue)) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && Object.prototype.propertyIsEnumerable.call(targetObject, prop))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}

// src/core/proxy.ts
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 /* Array */ : 0 /* Object */,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is$1(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 /* Array */ || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}

// src/core/immerClass.ts
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap$2(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet$2(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}

// src/core/current.ts
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
  } else {
    copy = shallowCopy(value, true);
  }
  each(copy, (key, childValue) => {
    set(copy, key, currentImpl(childValue));
  });
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}

// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
immer.produceWithPatches.bind(
  immer
);
immer.setAutoFreeze.bind(immer);
immer.setUseStrictShallowCopy.bind(immer);
immer.applyPatches.bind(immer);
immer.createDraft.bind(immer);
immer.finishDraft.bind(immer);

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
  if (typeof func !== "function") {
    throw new TypeError(errorMessage);
  }
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
  if (typeof object !== "object") {
    throw new TypeError(errorMessage);
  }
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
  if (!array.every((item) => typeof item === "function")) {
    const itemTypes = array.map(
      (item) => typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item
    ).join(", ");
    throw new TypeError(`${errorMessage}[${itemTypes}]`);
  }
}
var ensureIsArray = (item) => {
  return Array.isArray(item) ? item : [item];
};
function getDependencies(createSelectorArgs) {
  const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
  assertIsArrayOfFunctions(
    dependencies,
    `createSelector expects all input-selectors to be functions, but received the following types: `
  );
  return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
  const inputSelectorResults = [];
  const { length } = dependencies;
  for (let i = 0; i < length; i++) {
    inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
  }
  return inputSelectorResults;
}

// src/weakMapMemoize.ts
var StrongRef = class {
  constructor(value) {
    this.value = value;
  }
  deref() {
    return this.value;
  }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
  return {
    s: UNTERMINATED,
    v: void 0,
    o: null,
    p: null
  };
}
function weakMapMemoize(func, options = {}) {
  let fnNode = createCacheNode();
  const { resultEqualityCheck } = options;
  let lastResult;
  let resultsCount = 0;
  function memoized() {
    var _a, _b;
    let cacheNode = fnNode;
    const { length } = arguments;
    for (let i = 0, l = length; i < l; i++) {
      const arg = arguments[i];
      if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
        let objectCache = cacheNode.o;
        if (objectCache === null) {
          cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
        }
        const objectNode = objectCache.get(arg);
        if (objectNode === void 0) {
          cacheNode = createCacheNode();
          objectCache.set(arg, cacheNode);
        } else {
          cacheNode = objectNode;
        }
      } else {
        let primitiveCache = cacheNode.p;
        if (primitiveCache === null) {
          cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
        }
        const primitiveNode = primitiveCache.get(arg);
        if (primitiveNode === void 0) {
          cacheNode = createCacheNode();
          primitiveCache.set(arg, cacheNode);
        } else {
          cacheNode = primitiveNode;
        }
      }
    }
    const terminatedNode = cacheNode;
    let result;
    if (cacheNode.s === TERMINATED) {
      result = cacheNode.v;
    } else {
      result = func.apply(null, arguments);
      resultsCount++;
      if (resultEqualityCheck) {
        const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
        if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
          result = lastResultValue;
          resultsCount !== 0 && resultsCount--;
        }
        const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
        lastResult = needsWeakRef ? new Ref(result) : result;
      }
    }
    terminatedNode.s = TERMINATED;
    terminatedNode.v = result;
    return result;
  }
  memoized.clearCache = () => {
    fnNode = createCacheNode();
    memoized.resetResultsCount();
  };
  memoized.resultsCount = () => resultsCount;
  memoized.resetResultsCount = () => {
    resultsCount = 0;
  };
  return memoized;
}

// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
  const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
    memoize: memoizeOrOptions,
    memoizeOptions: memoizeOptionsFromArgs
  } : memoizeOrOptions;
  const createSelector2 = (...createSelectorArgs) => {
    let recomputations = 0;
    let dependencyRecomputations = 0;
    let lastResult;
    let directlyPassedOptions = {};
    let resultFunc = createSelectorArgs.pop();
    if (typeof resultFunc === "object") {
      directlyPassedOptions = resultFunc;
      resultFunc = createSelectorArgs.pop();
    }
    assertIsFunction(
      resultFunc,
      `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`
    );
    const combinedOptions = __spreadValues$1(__spreadValues$1({}, createSelectorCreatorOptions), directlyPassedOptions);
    const {
      memoize,
      memoizeOptions = [],
      argsMemoize = weakMapMemoize,
      argsMemoizeOptions = [],
      devModeChecks = {}
    } = combinedOptions;
    const finalMemoizeOptions = ensureIsArray(memoizeOptions);
    const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
    const dependencies = getDependencies(createSelectorArgs);
    const memoizedResultFunc = memoize(function recomputationWrapper() {
      recomputations++;
      return resultFunc.apply(
        null,
        arguments
      );
    }, ...finalMemoizeOptions);
    const selector = argsMemoize(function dependenciesChecker() {
      dependencyRecomputations++;
      const inputSelectorResults = collectInputSelectorResults(
        dependencies,
        arguments
      );
      lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
      return lastResult;
    }, ...finalArgsMemoizeOptions);
    return Object.assign(selector, {
      resultFunc,
      memoizedResultFunc,
      dependencies,
      dependencyRecomputations: () => dependencyRecomputations,
      resetDependencyRecomputations: () => {
        dependencyRecomputations = 0;
      },
      lastResult: () => lastResult,
      recomputations: () => recomputations,
      resetRecomputations: () => {
        recomputations = 0;
      },
      memoize,
      argsMemoize
    });
  };
  Object.assign(createSelector2, {
    withTypes: () => createSelector2
  });
  return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);

// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign(
  (inputSelectorsObject, selectorCreator = createSelector) => {
    assertIsObject(
      inputSelectorsObject,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`
    );
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map(
      (key) => inputSelectorsObject[key]
    );
    const structuredSelector = selectorCreator(
      dependencies,
      (...inputSelectorResults) => {
        return inputSelectorResults.reduce((composition, value, index) => {
          composition[inputSelectorKeys[index]] = value;
          return composition;
        }, {});
      }
    );
    return structuredSelector;
  },
  { withTypes: () => createStructuredSelector }
);

// src/index.ts
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose;
  return compose.apply(null, arguments);
};

// src/tsHelpers.ts
var hasMatchFunction = (v) => {
  return v && typeof v.match === "function";
};

// src/createAction.ts
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(formatProdErrorMessage(0) );
      }
      return __spreadValues(__spreadValues({
        type,
        payload: prepared.payload
      }, "meta" in prepared && {
        meta: prepared.meta
      }), "error" in prepared && {
        error: prepared.error
      });
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
function find(iterable, comparator) {
  for (const entry of iterable) {
    if (comparator(entry)) {
      return entry;
    }
  }
  return void 0;
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function emplace(map, key, handler) {
  if (map.has(key)) {
    let value = map.get(key);
    if (handler.update) {
      value = handler.update(value, key, map);
      map.set(key, value);
    }
    return value;
  }
  if (!handler.insert) throw new Error(formatProdErrorMessage(10) );
  const inserted = handler.insert(key, map);
  map.set(key, inserted);
  return inserted;
}

// src/getDefaultMiddleware.ts
function isBoolean(x) {
  return typeof x === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options != null ? options : {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  return middlewareArray;
};

// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = (options = {
  type: "raf"
}) => (next) => (...args) => {
  const store = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l) => l());
    }
  };
  return Object.assign({}, store, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      var _a;
      try {
        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};

// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options) {
  const {
    autoBatch = true
  } = options != null ? options : {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};

// src/configureStore.ts
function configureStore(options) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$1(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(formatProdErrorMessage(1) );
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  let finalCompose = compose;
  if (devTools) {
    finalCompose = composeWithDevTools(__spreadValues({
      // Enable capture of stack traces for dispatched Redux actions
      trace: "production" !== "production"
    }, typeof devTools === "object" && devTools));
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore(rootReducer, preloadedState, composedEnhancer);
}

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(formatProdErrorMessage(28) );
      }
      if (type in actionsMap) {
        throw new Error(formatProdErrorMessage(29) );
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addMatcher(matcher, reducer) {
      actionMatchers.push({
        matcher,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}

// src/createReducer.ts
function isStateFunction(x) {
  return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState)) {
    getInitialState = () => freezeDraftable(initialState());
  } else {
    const frozenInitialState = freezeDraftable(initialState);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher
    }) => matcher(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr) => !!cr).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result = caseReducer(draft, action);
          if (result === void 0) {
            return previousState;
          }
          return result;
        } else if (!isDraftable(previousState)) {
          const result = caseReducer(previousState, action);
          if (result === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw new Error(formatProdErrorMessage(9) );
          }
          return result;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}

// src/matchers.ts
var matches = (matcher, action) => {
  if (hasMatchFunction(matcher)) {
    return matcher.match(action);
  } else {
    return matcher(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher) => matches(matcher, action));
  };
}

// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21) => {
  let id = "";
  let i = size;
  while (i--) {
    id += urlAlphabet[Math.random() * 64 | 0];
  }
  return id;
};

// src/createAsyncThunk.ts
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    __publicField(this, "_type");
  }
};
var FulfillWithMeta = class {
  constructor(payload, meta) {
    this.payload = payload;
    this.meta = meta;
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    __publicField(this, "_type");
  }
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property of commonProperties) {
      if (typeof value[property] === "string") {
        simpleError[property] = value[property];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta) => ({
      payload,
      meta: __spreadProps(__spreadValues({}, meta || {}), {
        arg,
        requestId,
        requestStatus: "fulfilled"
      })
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta) => ({
      payload: void 0,
      meta: __spreadProps(__spreadValues({}, meta || {}), {
        arg,
        requestId,
        requestStatus: "pending"
      })
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta) => ({
      payload,
      error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
      meta: __spreadProps(__spreadValues({}, meta || {}), {
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: (error == null ? void 0 : error.name) === "AbortError",
        condition: (error == null ? void 0 : error.name) === "ConditionError"
      })
    }));
    function actionCreator(arg) {
      return (dispatch, getState, extra) => {
        const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        const promise = async function() {
          var _a, _b;
          let finalAction;
          try {
            let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_, reject) => {
              abortHandler = () => {
                reject({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler);
            });
            dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: (value, meta) => {
                return new RejectWithValue(value, meta);
              },
              fulfillWithValue: (value, meta) => {
                return new FulfillWithMeta(value, meta);
              }
            })).then((result) => {
              if (result instanceof RejectWithValue) {
                throw result;
              }
              if (result instanceof FulfillWithMeta) {
                return fulfilled(result.payload, requestId, arg, result.meta);
              }
              return fulfilled(result, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        }();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}

// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(slice, actionKey) {
  return `${slice}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  var _a;
  const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[asyncThunkSymbol];
  return function createSlice2(options) {
    const {
      name,
      reducerPath = name
    } = options;
    if (!name) {
      throw new Error(formatProdErrorMessage(11) );
    }
    if (typeof process !== "undefined" && "production" === "development") {
      if (options.initialState === void 0) {
        console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
      }
    }
    const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(formatProdErrorMessage(12) );
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(formatProdErrorMessage(13) );
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher, reducer2) {
        context.sliceMatchers.push({
          matcher,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name2, actionCreator) {
        context.actionCreators[name2] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name2, reducer2) {
        context.sliceCaseReducersByName[name2] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name, reducerName),
        createNotation: typeof options.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers];
      const finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
      return createReducer(options.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m of actionMatchers) {
          builder.addMatcher(m.matcher, m.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getInitialState();
          }
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = emplace(injectedSelectorCache, injected, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return emplace(selectorCache, selectState, {
          insert: () => {
            var _a2;
            const map = {};
            for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {})) {
              map[name2] = wrapSelector(selector, selectState, getInitialState, injected);
            }
            return map;
          }
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice = __spreadProps(__spreadValues({
      name,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState
    }, makeSelectorProps(reducerPath)), {
      injectInto(injectable, _a2 = {}) {
        var _b = _a2, {
          reducerPath: pathOpt
        } = _b, config = __objRest(_b, [
          "reducerPath"
        ]);
        const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config);
        return __spreadValues(__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
      }
    });
    return slice;
  };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      }
    }
    return selector(sliceState, ...args);
  }
  wrapper.unwrapped = selector;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config) {
    return __spreadValues({
      _reducerDefinitionType: "asyncThunk" /* asyncThunk */,
      payloadCreator
    }, config);
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer" /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */,
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(formatProdErrorMessage(17) );
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */;
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(formatProdErrorMessage(18) );
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options
  } = reducerDefinition;
  const thunk = cAT(type, payloadCreator, options);
  context.exposeAction(reducerName, thunk);
  if (fulfilled) {
    context.addCase(thunk.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop,
    pending: pending || noop,
    rejected: rejected || noop,
    settled: settled || noop
  });
}
function noop() {
}

// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = `task-${cancelled}`;
var taskCompleted = `task-${completed}`;
var listenerCancelled = `${listener}-${cancelled}`;
var listenerCompleted = `${listener}-${completed}`;
var TaskAbortError = class {
  constructor(code) {
    this.code = code;
    __publicField(this, "name", "TaskAbortError");
    __publicField(this, "message");
    this.message = `${task} ${cancelled} (reason: ${code})`;
  }
};

// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected) => {
  if (typeof func !== "function") {
    throw new Error(formatProdErrorMessage(32) );
  }
};
var noop2 = () => {
};
var catchRejection = (promise, onError = noop2) => {
  promise.catch(onError);
  return promise;
};
var addAbortSignalListener = (abortSignal, callback) => {
  abortSignal.addEventListener("abort", callback, {
    once: true
  });
  return () => abortSignal.removeEventListener("abort", callback);
};
var abortControllerWithReason = (abortController, reason) => {
  const signal = abortController.signal;
  if (signal.aborted) {
    return;
  }
  if (!("reason" in signal)) {
    Object.defineProperty(signal, "reason", {
      enumerable: true,
      value: reason,
      configurable: true,
      writable: true
    });
  }
  abortController.abort(reason);
};

// src/listenerMiddleware/task.ts
var validateActive = (signal) => {
  if (signal.aborted) {
    const {
      reason
    } = signal;
    throw new TaskAbortError(reason);
  }
};
function raceWithSignal(signal, promise) {
  let cleanup = noop2;
  return new Promise((resolve, reject) => {
    const notifyRejection = () => reject(new TaskAbortError(signal.reason));
    if (signal.aborted) {
      notifyRejection();
      return;
    }
    cleanup = addAbortSignalListener(signal, notifyRejection);
    promise.finally(() => cleanup()).then(resolve, reject);
  }).finally(() => {
    cleanup = noop2;
  });
}
var runTask = async (task2, cleanUp) => {
  try {
    await Promise.resolve();
    const value = await task2();
    return {
      status: "ok",
      value
    };
  } catch (error) {
    return {
      status: error instanceof TaskAbortError ? "cancelled" : "rejected",
      error
    };
  } finally {
    cleanUp == null ? void 0 : cleanUp();
  }
};
var createPause = (signal) => {
  return (promise) => {
    return catchRejection(raceWithSignal(signal, promise).then((output) => {
      validateActive(signal);
      return output;
    }));
  };
};
var createDelay = (signal) => {
  const pause = createPause(signal);
  return (timeoutMs) => {
    return pause(new Promise((resolve) => setTimeout(resolve, timeoutMs)));
  };
};

// src/listenerMiddleware/index.ts
var {
  assign
} = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises) => {
  const linkControllers = (controller) => addAbortSignalListener(parentAbortSignal, () => abortControllerWithReason(controller, parentAbortSignal.reason));
  return (taskExecutor, opts) => {
    assertFunction(taskExecutor);
    const childAbortController = new AbortController();
    linkControllers(childAbortController);
    const result = runTask(async () => {
      validateActive(parentAbortSignal);
      validateActive(childAbortController.signal);
      const result2 = await taskExecutor({
        pause: createPause(childAbortController.signal),
        delay: createDelay(childAbortController.signal),
        signal: childAbortController.signal
      });
      validateActive(childAbortController.signal);
      return result2;
    }, () => abortControllerWithReason(childAbortController, taskCompleted));
    if (opts == null ? void 0 : opts.autoJoin) {
      parentBlockingPromises.push(result.catch(noop2));
    }
    return {
      result: createPause(parentAbortSignal)(result),
      cancel() {
        abortControllerWithReason(childAbortController, taskCancelled);
      }
    };
  };
};
var createTakePattern = (startListening, signal) => {
  const take = async (predicate, timeout) => {
    validateActive(signal);
    let unsubscribe = () => {
    };
    const tuplePromise = new Promise((resolve, reject) => {
      let stopListening = startListening({
        predicate,
        effect: (action, listenerApi) => {
          listenerApi.unsubscribe();
          resolve([action, listenerApi.getState(), listenerApi.getOriginalState()]);
        }
      });
      unsubscribe = () => {
        stopListening();
        reject();
      };
    });
    const promises = [tuplePromise];
    if (timeout != null) {
      promises.push(new Promise((resolve) => setTimeout(resolve, timeout, null)));
    }
    try {
      const output = await raceWithSignal(signal, Promise.race(promises));
      validateActive(signal);
      return output;
    } finally {
      unsubscribe();
    }
  };
  return (predicate, timeout) => catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options) => {
  let {
    type,
    actionCreator,
    matcher,
    predicate,
    effect
  } = options;
  if (type) {
    predicate = createAction(type).match;
  } else if (actionCreator) {
    type = actionCreator.type;
    predicate = actionCreator.match;
  } else if (matcher) {
    predicate = matcher;
  } else if (predicate) ; else {
    throw new Error(formatProdErrorMessage(21) );
  }
  assertFunction(effect);
  return {
    predicate,
    type,
    effect
  };
};
var createListenerEntry = /* @__PURE__ */ assign((options) => {
  const {
    type,
    predicate,
    effect
  } = getListenerEntryPropsFrom(options);
  const id = nanoid();
  const entry = {
    id,
    effect,
    type,
    predicate,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(formatProdErrorMessage(22) );
    }
  };
  return entry;
}, {
  withTypes: () => createListenerEntry
});
var cancelActiveListeners = (entry) => {
  entry.pending.forEach((controller) => {
    abortControllerWithReason(controller, listenerCancelled);
  });
};
var createClearListenerMiddleware = (listenerMap) => {
  return () => {
    listenerMap.forEach(cancelActiveListeners);
    listenerMap.clear();
  };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo) => {
  try {
    errorHandler(errorToNotify, errorInfo);
  } catch (errorHandlerError) {
    setTimeout(() => {
      throw errorHandlerError;
    }, 0);
  }
};
var addListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/add`), {
  withTypes: () => addListener
});
var clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`);
var removeListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
  withTypes: () => removeListener
});
var defaultErrorHandler = (...args) => {
  console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {}) => {
  const listenerMap = /* @__PURE__ */ new Map();
  const {
    extra,
    onError = defaultErrorHandler
  } = middlewareOptions;
  assertFunction(onError);
  const insertEntry = (entry) => {
    entry.unsubscribe = () => listenerMap.delete(entry.id);
    listenerMap.set(entry.id, entry);
    return (cancelOptions) => {
      entry.unsubscribe();
      if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
        cancelActiveListeners(entry);
      }
    };
  };
  const startListening = (options) => {
    let entry = find(Array.from(listenerMap.values()), (existingEntry) => existingEntry.effect === options.effect);
    if (!entry) {
      entry = createListenerEntry(options);
    }
    return insertEntry(entry);
  };
  assign(startListening, {
    withTypes: () => startListening
  });
  const stopListening = (options) => {
    const {
      type,
      effect,
      predicate
    } = getListenerEntryPropsFrom(options);
    const entry = find(Array.from(listenerMap.values()), (entry2) => {
      const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
      return matchPredicateOrType && entry2.effect === effect;
    });
    if (entry) {
      entry.unsubscribe();
      if (options.cancelActive) {
        cancelActiveListeners(entry);
      }
    }
    return !!entry;
  };
  assign(stopListening, {
    withTypes: () => stopListening
  });
  const notifyListener = async (entry, action, api, getOriginalState) => {
    const internalTaskController = new AbortController();
    const take = createTakePattern(startListening, internalTaskController.signal);
    const autoJoinPromises = [];
    try {
      entry.pending.add(internalTaskController);
      await Promise.resolve(entry.effect(
        action,
        // Use assign() rather than ... to avoid extra helper functions added to bundle
        assign({}, api, {
          getOriginalState,
          condition: (predicate, timeout) => take(predicate, timeout).then(Boolean),
          take,
          delay: createDelay(internalTaskController.signal),
          pause: createPause(internalTaskController.signal),
          extra,
          signal: internalTaskController.signal,
          fork: createFork(internalTaskController.signal, autoJoinPromises),
          unsubscribe: entry.unsubscribe,
          subscribe: () => {
            listenerMap.set(entry.id, entry);
          },
          cancelActiveListeners: () => {
            entry.pending.forEach((controller, _, set) => {
              if (controller !== internalTaskController) {
                abortControllerWithReason(controller, listenerCancelled);
                set.delete(controller);
              }
            });
          },
          cancel: () => {
            abortControllerWithReason(internalTaskController, listenerCancelled);
            entry.pending.delete(internalTaskController);
          },
          throwIfCancelled: () => {
            validateActive(internalTaskController.signal);
          }
        })
      ));
    } catch (listenerError) {
      if (!(listenerError instanceof TaskAbortError)) {
        safelyNotifyError(onError, listenerError, {
          raisedBy: "effect"
        });
      }
    } finally {
      await Promise.all(autoJoinPromises);
      abortControllerWithReason(internalTaskController, listenerCompleted);
      entry.pending.delete(internalTaskController);
    }
  };
  const clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
  const middleware = (api) => (next) => (action) => {
    if (!isAction(action)) {
      return next(action);
    }
    if (addListener.match(action)) {
      return startListening(action.payload);
    }
    if (clearAllListeners.match(action)) {
      clearListenerMiddleware();
      return;
    }
    if (removeListener.match(action)) {
      return stopListening(action.payload);
    }
    let originalState = api.getState();
    const getOriginalState = () => {
      if (originalState === INTERNAL_NIL_TOKEN) {
        throw new Error(formatProdErrorMessage(23) );
      }
      return originalState;
    };
    let result;
    try {
      result = next(action);
      if (listenerMap.size > 0) {
        const currentState = api.getState();
        const listenerEntries = Array.from(listenerMap.values());
        for (const entry of listenerEntries) {
          let runListener = false;
          try {
            runListener = entry.predicate(action, currentState, originalState);
          } catch (predicateError) {
            runListener = false;
            safelyNotifyError(onError, predicateError, {
              raisedBy: "predicate"
            });
          }
          if (!runListener) {
            continue;
          }
          notifyListener(entry, action, api, getOriginalState);
        }
      }
    } finally {
      originalState = INTERNAL_NIL_TOKEN;
    }
    return result;
  };
  return {
    middleware,
    startListening,
    stopListening,
    clearListeners: clearListenerMiddleware
  };
};

// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
  return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

var Z=Object.defineProperty,ee$1=Object.defineProperties;var te=Object.getOwnPropertyDescriptors;var V=Object.getOwnPropertySymbols;var re=Object.prototype.hasOwnProperty,oe=Object.prototype.propertyIsEnumerable;var j$1=(e,t,r)=>t in e?Z(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,P=(e,t)=>{for(var r in t||(t={}))re.call(t,r)&&j$1(e,r,t[r]);if(V)for(var r of V(t))oe.call(t,r)&&j$1(e,r,t[r]);return e},A$1=(e,t)=>ee$1(e,te(t));var C=(e,t,r)=>new Promise((o,n)=>{var p=g=>{try{d(r.next(g));}catch(l){n(l);}},c=g=>{try{d(r.throw(g));}catch(l){n(l);}},d=g=>g.done?o(g.value):Promise.resolve(g.value).then(p,c);d((r=r.apply(e,t)).next());});var ne$1=Object.defineProperty,G=Object.getOwnPropertySymbols,ie$1=Object.prototype.hasOwnProperty,se$1=Object.prototype.propertyIsEnumerable,Y=(e,t,r)=>t in e?ne$1(e,t,{enumerable:!0,configurable:!0,writable:!0,value:r}):e[t]=r,m=(e,t)=>{for(var r in t||(t={}))ie$1.call(t,r)&&Y(e,r,t[r]);if(G)for(var r of G(t))se$1.call(t,r)&&Y(e,r,t[r]);return e},ae$1=(e=>(e.LIGHT="Light",e.COLOR="Color",e))(ae$1||{}),pe$1=(e=>(e.CONFIRMED="CONFIRMED",e.UNCONFIRMED_BUT_PLAUSIBLE="UNCONFIRMED_BUT_PLAUSIBLE",e.UNCONFIRMED_BUT_SUSPICIOUS="UNCONFIRMED_BUT_SUSPICIOUS",e))(pe$1||{}),ce=(e=>(e.ROUTE="route",e.STREET_NUMBER="street_number",e.STREET_ADDRESS="street_address",e.SUBPREMISE="subpremise",e.LOCALITY="locality",e.STATE="administrative_area_level_1",e.POSTAL_CODE="postal_code",e.POSTAL_CODE_SUFFIX="postal_code_suffix",e))(ce||{}),le=(e=>(e.STREET_1="street_1",e.STREET_2="street_2",e.CITY="city",e.STATE="state",e.ZIPCODE="zipcode",e))(le||{});var ue=(e=>(e.ApplicationForms="application_forms",e.PartnerPhoneCalls="partner_phone_calls",e.FeatureCheck="features",e.Questions="questions",e.Rules="rules",e.RuleExcludedChoices="rule_excluded_choices",e.SearchableQuestions="searchable_questions",e.SendToExchange="send_to_exchange",e.TakeOver="take_over",e))(ue||{}),de$1=(e=>(e.NotConnected="NotConnected",e.Connected="Connected",e.Disconnected="Disconnected",e.Connecting="Connecting",e.Disconnecting="Disconnecting",e))(de$1||{}),me$1=(e=>(e.Create="create",e.Index="index",e.Show="show",e.Update="update",e))(me$1||{}),f$1=(e=>(e.Development="development",e.Alpha="alpha",e.Beta="beta",e.Production="prod",e))(f$1||{}),Ie=(e=>(e.Accepted="Accepted",e.Expired="Expired",e.Not_Created="Not created",e.Queued="Queued to send",e.Sent="Sent",e))(Ie||{}),_e=(e=>(e.token="token",e.cableToken="cable_token",e.user="user",e.state="state",e.expiresAt="expiresAt",e.refreshAt="refreshAt",e.impersonated="impersonated",e.terminalTheme="terminalTheme",e))(_e||{}),ge$1=(e=>(e.NotLoaded="NotLoaded",e.Loading="Loading",e.Loaded="Loaded",e.Configured="Configured",e.Error="Error",e))(ge$1||{}),fe$1=(e=>(e.Healthy="Healthy",e.Error="Error",e))(fe$1||{}),he=(e=>(e.OAuth="OAuth",e.Login="Login",e))(he||{}),Pe$1=(e=>(e.storageKey="BP_SDK_ANALYTICS_VARS",e.additionalQuoteOnline="onlinebuy",e.additionalQuoteOffline="nobuy",e))(Pe$1||{}),Ae$1=(e=>(e.activeIdUpdate="activeIdUpdate",e.activeQuestionSetChange="activeQuestionSetChange",e.addItem="addItem",e.answerStateChanged="answerStateChanged",e.bpAnalyticsTrack="bpAnalyticsTrack",e.closePanel="closePanel",e.deleteItem="deleteItem",e.deletePool="deletePool",e.epFieldChanged="epFieldChanged",e.errorsUpdate="errorsUpdate",e.fakeValueUpdate="fakeValueUpdate",e.filterUpdate="filterUpdate",e.formLoaded="formLoaded",e.nudgeAnswer="nudgeAnswer",e.openPanel="openPanel",e.placesUpdate="placesUpdate",e.questionSetAdded="questionSetAdded",e.questionSetCompletionChanged="questionSetCompletionChanged",e.quoteFailure="quoteFailure",e.quotesChanged="quotesChanged",e.quoteSuccess="quoteSuccess",e.removeActiveAnswer="removeActiveAnswer",e.saveAnswer="saveAnswer",e.saveVehicle="saveVehicle",e.sdkError="sdkError",e.tabChanged="tabChanged",e.updateActiveAnswer="updateActiveAnswer",e.userAuthenticationChanged="userAuthenticationChanged",e.valueUpdate="valueUpdate",e.vinUpdate="vinUpdate",e.ymmcUpdate="ymmcUpdate",e))(Ae$1||{}),Ce=(e=>(e.Address="address",e.Accordion="accordion",e.AccumulatePercentage="accumulate_percentage",e.Vehicle="vehicle",e.Driver="driver",e.Stepper="stepper",e.Step="step",e.Coverage="coverage",e.AutoCollapsedAccordion="auto_collapsed_accordion",e.ValidatedAddress="validated_address",e))(Ce||{}),E$1=(e=>(e.Address="address",e.Anchor="anchor",e.CheckBox="checkbox",e.CoverageType="coverage_type",e.Currency="currency",e.Date="date",e.DeletePool="delete_pool",e.Dialog="dialog",e.DriversLicense="drivers_license",e.DropDown="dropdown",e.Email="email",e.FederalEmployeeIdentification="fein",e.JSON="json",e.Label="label",e.Masked="masked",e.MonthYear="month_year",e.Number="number",e.Object="object",e.Percentage="percentage",e.Phone="phone",e.Radio="radio",e.Select="select",e.SocialSecurityNumber="ssn",e.Step="step",e.Tenant="tenant",e.Text="text",e.Vehicle="vehicle",e.Url="url",e.VIN="vin",e.Year="year",e.ZipCode="zipcode",e))(E$1||{}),Ee$1=(e=>(e.Accumulator="accumulator",e.AddressJSON="address_json",e.BusinessClass="business_class",e.City="city",e.CommercialAutoACV="ca_acv",e.CommercialAutoCategory="ca_category",e.CommercialAutoCount="ca_count",e.CommercialAutoDrivetrain="ca_drivetrain",e.CommercialAutoFlow="ca_flow",e.CommercialAutoGCW="ca_gcw",e.CommercialAutoGVW="ca_gvw",e.CommercialAutoJson="ca_json",e.CommercialAutoMake="ca_make",e.CommercialAutoModel="ca_model",e.CommercialAutoMSRP="ca_msrp",e.CommercialAutoSubModel="ca_submodel",e.CommercialAutoTractor="ca_tractor",e.CommercialAutoVIN="ca_vin",e.CommercialAutoYear="ca_year",e.County="county",e.DriversLicenseState="drivers_license_state",e.Indent="indent",e.Increment="increment",e.JornayaLeadID="jornaya_lead_id",e.LinesOfBusiness="lines_of_business",e.LinesOfBusinessAdditional="lines_of_business_additional",e.MotorVehicleReportComplete="mvr_complete",e.MotorVehicleReportState="mvr_state",e.MotorVehicleReportCondition="mvr_report_condition",e.State="state",e.Street1="street_1",e.Street2="street_2",e.ZipCode="zipcode",e))(Ee$1||{}),ve=(e=>(e.CoverageLimit="coverage limit",e))(ve||{}),Te=(e=>(e.MaximumDate="maxDate",e.MaximumValue="max",e.MinimumDate="minDate",e.MinimumValue="min",e.Pattern="pattern",e.Required="required",e))(Te||{}),Re=(e=>(e.Acord="acord",e.Acord125="acord_125",e.Acord126="acord_126",e.Acord130="acord_130",e))(Re||{}),Se$1=(e=>(e.Binding="binding",e))(Se$1||{}),ke=(e=>(e.BP_QUOTABLE="bp_quotable",e.OFFLINE="offline",e.ONLINE="online",e))(ke||{}),ye=(e=>(e.Pending="pending",e.Queued="queued",e.Executing="executing",e.Completed="completed",e.Failed="failed",e.Aborted="aborted",e))(ye||{}),be=(e=>(e.ClueReport="ClueReport",e.MotorVehicleReport="MotorVehicleReport",e.RequestPrefill="RequestPrefill",e.DriverScore="DriverScore",e.JornayaAudit="JornayaAudit",e.DotNumber="DotNumber",e))(be||{}),$e=(e=>(e.Incomplete="incomplete",e.InProgress="in_progress",e.Completed="completed",e.Quoted="quoted",e))($e||{}),He=(e=>(e.not_permitted_to_bind="not_permitted_to_bind",e.sent_to_wholesaler="sent_to_wholesaler",e.programmatic_bind="programmatic_bind",e))(He||{}),Fe=(e=>(e.dialog="dialog",e.wholesale_workflow="wholesale_workflow",e.programmatic_bind_workflow="programmatic_bind_workflow",e.send_to_underwriting="send_to_underwriting",e))(Fe||{}),we=(e=>(e.NON_ADMITTED="non_admitted",e.WHOLESALER="wholesaler",e.INSTANT_ENROLLMENT="instant_enrollment",e.ADDITIONAL_MARKET="additional_market",e.OPT_IN_QUOTE_FLOW="opt_in_quote_flow",e))(we||{});var Oe$1=(e=>(e.Sub="sub",e.Direct="direct",e.PlacementDesk="placement_desk",e))(Oe$1||{}),Ue$1=(e=>(e.Answer="answer",e.Application="application_form",e.QuoteRequest="quote_request",e))(Ue$1||{}),Qe$1=(e=>(e.error="error",e.info="info",e.warning="warning",e))(Qe$1||{}),qe$1=(e=>(e.Question="question",e.QuestionSet="question_set",e.QuotePresentation="quote_presentation",e))(qe$1||{}),xe=(e=>(e.RateIndication="rate_indication",e.ReadyToBind="ready_to_bind",e))(xe||{}),Ne$1=(e=>(e.unsent="unsent",e.in_progress="in_progress",e.sent="sent",e.completed="completed",e.failed="failed",e.timed_out="timed_out",e.ineligible="ineligible",e.referral="referral",e.bound="bound",e))(Ne$1||{}),Le$1=(e=>(e.AddQuestionSet="application_forms_question_set",e.Answer="answer",e.Appetite="appetite",e.ApplicationForm="application_form",e.ApplicationFormPercentCompleted="application_form_percent_completed",e.ApplicationFormProcess="application_form_process",e.Batch="batch",e.CarrierProducts="eligible_carriers_products",e.Message="message",e.Notification="notification",e.QuoteRequest="quote_request",e.RealTimeEligibility="real_time_eligibility",e.RemoveQuestionSet="destroy_application_forms_question_set",e))(Le$1||{}),De=(e=>(e.AcordForm="acord_form_pdf",e.AgentQuoteStart="agent_quote_start",e.ClientQuoteStart="client_quote_start",e.Storefront="storefront",e))(De||{}),Be$1=(e=>(e.NotLoaded="NotLoaded",e.Loading="Loading",e.Loaded="Loaded",e.Error="Error",e))(Be$1||{});var Me$1={configurations:{},makes:{},models:{},selection:{},vin:{},years:{}},Ve$1={list:[],isLoaded:!1,status:"NotLoaded"},je={filteredOnlineQuotes:[],filteredOfflineQuotes:[]},Ge=(e=>(e.FIX="fix",e.ACCEPT="accept",e.CONFIRM="confirm",e.TYPO="typo",e))(Ge||{}),Ye=(e=>(e.REQUIRED="required",e.READY_TO_VALIDATE="ready to validate",e.VALIDATED="validated",e.PROCEED_NEXT="proceed next",e.COMPLETED="completed",e.VALIDATION_ERROR="error",e))(Ye||{}),We=(e=>(e.EDIT="return to edit address",e.AS_ENTERED="continue with original address",e.CONFIRM="continue with confirm suggested address",e.MISSING_FIX="continue with missing input fix",e))(We||{}),ze$1={verdict:null,responseId:"",address:null,stagedAnswers:[],validationStatus:"required",attempt:0,originalAddress:""};({vehicleOptions:m({},Me$1),features:m({},Ve$1),quotes:m({},je),addressValidation:m({},ze$1)});var Je$1={configurations:{},makes:{},models:{},selection:{},vins:{},years:{}},x$1={state:"NotLoaded",map:{}},W$1={state:"NotLoaded"},Ke$1={form:"NotLoaded"},Xe$1={answers:m({},x$1),application:m({},Ke$1),bindQuotes:{},choices:{},carriersProducts:m({},W$1),questionPools:m({},x$1),questionSets:m({},x$1),quotes:m({},W$1),refilters:{},vehicles:m({},Je$1)},Ze$1={auth:"NotLoaded",config:"NotLoaded",health:"Healthy",state:"NotLoaded",user:"NotLoaded",socket:"NotConnected",socketId:""};({remote:m({},Xe$1),local:m({},Ze$1)});var et$1=(e=>(e.QuestionSetSaved="QuestionSetSaved",e.AddressValidation_ValidatedOnFirstAttempt="AddressValidOnFirstAttempt",e.AddressValidation_Verdict="AddressValidationVerdict",e.AddressValidation_CTAClicked="AddressValidationCTAClicked",e.AddressValidation_ValidationError="AddressValidationValidationError",e))(et$1||{});var tt=(e=>(e.Configuration="configuration",e.Make="make",e.Model="model",e.Year="year",e))(tt||{});var rt$1=(e=>(e.AtvByYearMakeModel="atv",e.TrailerByYearMakeModel="trailer",e.AutomobileByYearMakeModel="ymm",e.VehicleByVin="vin",e))(rt$1||{}),ot$1=(e=>(e.Atv="ATVs/UTVs",e.Trailer="Trailers",e))(ot$1||{}),nt$1=(e=>(e.AutomobileByYearMakeModel="Year / Make / Model",e.VehicleByVin="VIN",e.TrailerByYearMakeModel="Trailer",e.AtvByYearMakeModel="ATV/UTV",e))(nt$1||{});function a(e){return e.uri?e.uri:e.env===f$1.Production||e.env===void 0?"https://partner-engine.boldpenguin.com":e.env===f$1.Development?"http://localhost:8080":`https://partner-engine-uat.${e.env}.boldpenguin.com`}function u(e){return e.authUri?e.authUri:e.env===f$1.Production||e.env===void 0?"https://boldpenguin-auth.boldpenguin.com":e.env===f$1.Development?"http://localhost:3000":`https://boldpenguin-auth-uat.${e.env}.boldpenguin.com`}var z="14.0.0-internal-20250708163815";function i(e,t="GET",r){let o=new Headers({Accept:"application/json","Content-Type":"application/json","x-sdk-version":z});e&&o.append("Authorization",`Bearer ${e}`);let n={credentials:"include",method:t,headers:o};return r&&(n.body=JSON.stringify(r)),n}function I(e){let t="",r=Object.entries(e!=null?e:{}).filter(([,o])=>o);return r.length>0&&(t=`?${r.map(([n,p])=>{let c=encodeURIComponent(n),d=encodeURIComponent(p);return `${c}=${d}`}).join("&")}`),t}var s=(e,t,r)=>new Promise((o,n)=>{fetch(e,t).then(p=>{let c;return r!=null&&r.expectsEmptyResponse?c=ct:r!=null&&r.couldHaveEmptyResponse?c=at$1:r!=null&&r.expectBlob?c=lt:c=pt$1,c(p,o,n)}).catch(p=>st(p,n));});function st(e,t){let r={error:e};e.error&&(r=e),t(r);}function J(e,t,r){let o=A$1(P({},t||{}),{error:e});r(o);}function at$1(e,t,r){return e.ok?t(h$1(e)):r(h$1(e))}function pt$1(e,t,r){return e.json().then(o=>{let n=h$1(e,o);(e.ok?t:r)(n);}).catch(o=>J(o,e,r))}function ct(e,t,r){let o=h$1(e);(e.ok?t:r)(o);}function lt(e,t,r){return e.blob().then(o=>{let n=h$1(e,o);(e.ok?t:r)(n);}).catch(o=>J(o,e,r))}function h$1(e,t){return {status:e.status,redirected:e.redirected,url:e.url,metadata:{searchTotalItems:Number(e.headers.get("x-total"))},parsedBody:t}}var v$1=class e{static updateAnswer(t,r){let o=`${a(r)}/application_forms/${t.application_form_id}/answers/${t.id}`;return s(o,i(r.token,"PATCH",e.transformAnswerData(t)))}static transformAnswerData(t){let r;return t.question.field_type===E$1.Select?r=null:t.question.field_type===E$1.CheckBox?r=t.value?"1":null:r=t.value,{answer:{choice_id:t.choice_id,choice_ids:t.choice_ids,value:r,previous_version:t.version,question_id:t.question.id}}}};var T$1=class{static getApplicationForm(t,r){let o=`${a(r)}/application_forms/${t}`;return s(o,i(r.token))}static getLatestApplicationForm(t,r){let o=`${a(r)}/application_forms/${t}/latest`;return s(o,i(r.token))}static getApplicationFormEitScenario(t,r){let o=`${a(r)}/application_forms/${t}/export/eit_scenario`;return s(o,i(r.token),{expectBlob:!0})}static createExchangeApplicationForm(t,r){let o=`${a(r)}/exchange_application_forms`;return s(o,i(r.token,"POST",t))}static createApplicationForm(t,r){let o=`${a(r)}/application_forms`;return s(o,i(r.token,"POST",t))}static createTenantApplicationForm(t,r,o){let n=`${a(r)}/tenants/${o}/application_forms`;return s(n,i(r.token,"POST",t))}static cloneApplicationForm(t,r){let o=`${a(r)}/application_forms/${t}/clones`;return s(o,i(r.token,"POST"))}static updateApplicationForm(t,r){let o=`${a(r)}/application_forms/${t.id}`;return s(o,i(r.token,"PATCH",t))}static deleteApplicationForm(t,r){let o=`${a(r)}/application_forms/${t.id}`;return s(o,i(r.token,"DELETE"))}static getApplicationFormFromToken(t,r){let o=`${a(r)}/tokens/${t}`;return s(o,i(r.token,"GET"))}static getTokenForAuthGuestFlow(t){let r=a(t);return s(`${r}/tenants/${t.tenantId}/application_forms/guest`,i(void 0,"POST",{source:t.applicationSource,source_metadata:t.applicationMetadata,application_form:t.applicationForm}))}static searchApplicationForms(t,{sortColumn:r="",sortOrder:o="asc",pageNumber:n=0,pageSize:p=10,answers:c=[],q:d=""}={}){let g=I({column:r,order:o,page:n.toString(),per_page:p.toString(),questions:this.serializeAnswers(c),q:d}),l=`${a(t)}/application_forms/${g}`;return s(l,i(t.token))}static getEligibilityResults(t,r){let o=`${a(r)}/application_forms/${t}/eligibility_results`;return s(o,i(r.token,"GET"))}static updateApplicationToNextBucket(t,r,o){let n=`${a(o)}/application_forms/${t}/add_next_bucket`;return s(n,i(o.token,"POST",{product_codes:r}),{expectsEmptyResponse:!0})}static createCurrentTierSkips(t,r){let o=`${a(r)}/application_forms/${t.id}/current_tier_skips`;return s(o,i(r.token,"POST"))}static createCurrentTierSkipsByAppFormId(t,r){let o=`${a(r)}/application_forms/${t}/current_tier_skips`;return s(o,i(r.token,"POST"),{expectsEmptyResponse:!0})}static bindReview(t,r,o){let n=`${a(o)}/application_forms/${r}/bind_review`;return s(n,i(o.token,"POST",{quote_request_id:t}))}static deleteBindReview(t,r){let o=`${a(r)}/application_forms/${t}/bind_review`;return s(o,i(r.token,"DELETE"),{expectsEmptyResponse:!0})}static serializeAnswers(t){let r={};for(let o of t)r[o.question.id]={value:o.value,choice_ids:o.choice_ids,choice:o.choice_id};return JSON.stringify(r)}static getCarrierPortalUrl(t,r,o){let n=`${a(o)}/application_forms/${t}/carriers/${r}/portal_url`;return s(n,i(o.token))}};var R=class{static getQuestionSet(t,r,o){let n=`${a(o)}/application_forms/${t.id}/application_forms_question_sets/${r.id}`;return s(n,i(o.token))}static updateQuestionSet(t,r){let o=`${a(r)}/application_forms/${t.application_form_id}/application_forms_question_sets/${t.id}`;return s(o,i(r.token,"PATCH",this.transformQuestionSetDataForUpdate(t)))}static createQuestionSet(t,r){let o=`${a(r)}/application_forms/${t.application_form_id}/application_forms_question_sets`;return s(o,i(r.token,"POST",this.transformQuestionSetDataForCreate(t)))}static transformQuestionSetDataForUpdate(t){return {application_forms_question_set:{is_completed:t.is_completed}}}static transformQuestionSetDataForCreate(t){return {application_forms_question_set:{question_set:{code:t.question_set.code}}}}};var S$1=class{static getAttachment(t,r){return C(this,null,function*(){let o=`${a(r)}/attachments/${t}`;return s(o,i(r.token,"GET"),{expectBlob:!0})})}};function N(e){let t={};return Object.keys(e).forEach(r=>{e[r]&&(t[r]=e[r]);}),t}var b$1=class e{static getChoices(t,r){let o=`${a(r)}/questions/${t}/choices`;return s(o,i(r.token))}static getChoice(t,r){let o=`${a(r)}/choices/${t}`;return s(o,i(r.token))}static addChoice(t,r){return s(`${a(r)}/choices`,i(r.token,"POST",e.toChoiceObject(t)))}static updateChoice(t,r){let o=`${a(r)}/choices/${t.id}`;return s(o,i(r.token,"PATCH",e.toChoiceObject(t)))}static searchChoices(t,r,o){let n=N(r),p=`${a(o)}/questions/${t}/choices${I(n)}`;return s(p,i(o.token))}static searchChoicesWithNudges(t,r,o){let n=N(r),p=`${a(o)}/questions/${t}/choices${I(n)}`;return s(p,i(o.token))}static toChoiceObject(t){return {choice:{value:t.value,alias:t.alias,question_id:t.question_id,order:t.order}}}};var $=class{static getFeatures(t){let r=`${a(t)}/features`;return s(r,i(t.token,"GET"))}};var H=class{static addQuestionPool({application_id:t,config:r,question_pool_id:o,parent_answer_pool_id:n}){let p=`${a(r)}/application_forms/${t}/answer_pools`;return s(p,i(r.token,"POST",{question_pool_id:o,parent_answer_pool_id:n}))}static removeQuestionPool({application_id:t,config:r,answer_pool_id:o}){let n=`${a(r)}/application_forms/${t}/answer_pools/${o}`;return s(n,i(r.token,"DELETE"))}};var F=class{static getApplicationFormCarriersProducts(t,r){let o=`${a(r)}/application_forms/${t}/carriers_products`;return s(o,i(r.token))}};var w$1=class e{static getQuoteRequests(t,r){let o=`${a(r)}/application_forms/${t}/quote_requests`;return s(o,i(r.token))}static bindQuoteAction(t,r,o){let n=I({bind_action:t.value}),p=`${a(o)}/application_forms/${r.application_form_id}/quote_requests/${r.id}/bind/${n}`;return s(p,i(o.token),{couldHaveEmptyResponse:!0})}static bindQuote(t,r,o,n){let p=`${a(o)}/application_forms/${r}/quote_requests/${t}/bind`;if(n){let c=I({action_type:n});p=`${p}/${c}`;}return s(p,i(o.token))}static bindAndPayQuote(t,r,o,n,p,c){let d=`${a(c)}/application_forms/${r}/quote_requests/${t}/bind_and_pay`;return s(d,i(c.token,"POST",A$1(P({},p),{plan_id:o,automatic_payments:n})),{expectsEmptyResponse:!0})}static updatePaymentPlan(t,r,o,n){let p=`${a(n)}/application_forms/${r}/quote_requests/${t}/payment_plan`;return s(p,i(n.token,"PUT",{plan_id:o}))}static quoteDetails(t,r){let o=`${a(r)}/application_forms/${t.application_form_id}/quote_requests/${t.id}/details`;return s(o,i(r.token))}static updateQuote(t,r){let o=`${a(r)}/application_forms/${t.application_form_id}/quote_requests/${t.id}`;return s(o,i(r.token,"PATCH",e.toQuoteRequestObject(t)))}static paymentStrategy(t,r,o,n,p){let c=`${a(n)}/application_forms/${r}/quote_requests/${t}/payment_strategy`;return s(c,i(n.token,"POST",{plan_id:o,origin_url:p}))}static toQuoteRequestObject(t){return {quote_request:{focused:t.focused}}}static sendToPlacementDesk(t,r,o){let n=`${a(o)}/application_forms/${r}/quote_requests/${t}/send_to_placement_desk`;return s(n,i(o.token,"PUT",{}),{expectsEmptyResponse:!0})}};var O=class{static getStorefrontByCode(t,r){let o=`${u(r)}/api/storefronts/${t}`,n=i();return s(o,n)}};var q$1=class{static getYears(t){let r=`${a(t)}/vehicles/years`;return s(r,i(t.token))}static getMakes(t,r,o){let n=I({type:o==null?void 0:o.category,name:o==null?void 0:o.name}),p=`${a(r)}/vehicles/years/${t}/makes${n}`;return s(p,i(r.token))}static getModels(t,r,o,n){let p=I({type:n}),c=`${a(o)}/vehicles/years/${t}/makes/${r}/models${p}`;return s(c,i(o.token))}static getConfigurations(t,r,o,n,p){let c=I({type:p}),d=`${a(n)}/vehicles/years/${t}/makes/${r}/models/${o}/configurations${c}`;return s(d,i(n.token))}static getVinDetails(t,r){let o=`${a(r)}/vehicles/vins/${t}`;return s(o,i(r.token))}static selectVehicle(t){var D,B,M;let{appId:r,questionGroupId:o,configurationId:n,inputMethod:p,config:c,answerPoolId:d,category:g,vehicle:l}=t,L={question_group_id:o,configuration_id:n,flow:p,answer_pool_id:d};d||delete L.answer_pool_id;let K=I({type:g,year:(D=l==null?void 0:l.yearId)!=null?D:void 0,make:(B=l==null?void 0:l.makeId)!=null?B:void 0,model:(M=l==null?void 0:l.modelId)!=null?M:void 0}),X=`${a(c)}/application_forms/${r}/vehicles${K}`;return s(X,i(c.token,"POST",L))}};

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */

function arrayEach$1(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var _arrayEach = arrayEach$1;

var baseAssignValue$1 = _baseAssignValue,
    eq = eq_1;

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue$2(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue$1(object, key, value);
  }
}

var _assignValue = assignValue$2;

var assignValue$1 = _assignValue,
    baseAssignValue = _baseAssignValue;

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject$4(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue$1(object, key, newValue);
    }
  }
  return object;
}

var _copyObject = copyObject$4;

var copyObject$3 = _copyObject,
    keys$1 = keys_1;

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign$1(object, source) {
  return object && copyObject$3(source, keys$1(source), object);
}

var _baseAssign = baseAssign$1;

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */

function nativeKeysIn$1(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

var _nativeKeysIn = nativeKeysIn$1;

var isObject$2 = isObject_1,
    isPrototype$1 = _isPrototype,
    nativeKeysIn = _nativeKeysIn;

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn$1(object) {
  if (!isObject$2(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype$1(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

var _baseKeysIn = baseKeysIn$1;

var arrayLikeKeys = _arrayLikeKeys,
    baseKeysIn = _baseKeysIn,
    isArrayLike = isArrayLike_1;

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn$3(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

var keysIn_1 = keysIn$3;

var copyObject$2 = _copyObject,
    keysIn$2 = keysIn_1;

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn$1(object, source) {
  return object && copyObject$2(source, keysIn$2(source), object);
}

var _baseAssignIn = baseAssignIn$1;

var _cloneBuffer = {exports: {}};

(function (module, exports) {
var root = _root;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;
}(_cloneBuffer, _cloneBuffer.exports));

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */

function copyArray$1(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

var _copyArray = copyArray$1;

var copyObject$1 = _copyObject,
    getSymbols$1 = _getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols$1(source, object) {
  return copyObject$1(source, getSymbols$1(source), object);
}

var _copySymbols = copySymbols$1;

var overArg = _overArg;

/** Built-in value references. */
var getPrototype$2 = overArg(Object.getPrototypeOf, Object);

var _getPrototype = getPrototype$2;

var arrayPush = _arrayPush,
    getPrototype$1 = _getPrototype,
    getSymbols = _getSymbols,
    stubArray = stubArray_1;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn$2 = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype$1(object);
  }
  return result;
};

var _getSymbolsIn = getSymbolsIn$2;

var copyObject = _copyObject,
    getSymbolsIn$1 = _getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn$1(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

var _copySymbolsIn = copySymbolsIn$1;

var baseGetAllKeys = _baseGetAllKeys,
    getSymbolsIn = _getSymbolsIn,
    keysIn$1 = keysIn_1;

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn$1(object) {
  return baseGetAllKeys(object, keysIn$1, getSymbolsIn);
}

var _getAllKeysIn = getAllKeysIn$1;

/** Used for built-in method references. */

var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray$1(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

var _initCloneArray = initCloneArray$1;

var Uint8Array = _Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer$3(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

var _cloneArrayBuffer = cloneArrayBuffer$3;

var cloneArrayBuffer$2 = _cloneArrayBuffer;

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView$1(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$2(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

var _cloneDataView = cloneDataView$1;

/** Used to match `RegExp` flags from their coerced string values. */

var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp$1(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

var _cloneRegExp = cloneRegExp$1;

var Symbol$1 = _Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$1 ? Symbol$1.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol$1(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

var _cloneSymbol = cloneSymbol$1;

var cloneArrayBuffer$1 = _cloneArrayBuffer;

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray$1(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer$1(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

var _cloneTypedArray = cloneTypedArray$1;

var cloneArrayBuffer = _cloneArrayBuffer,
    cloneDataView = _cloneDataView,
    cloneRegExp = _cloneRegExp,
    cloneSymbol = _cloneSymbol,
    cloneTypedArray = _cloneTypedArray;

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$1 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag$1(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$1:
      return cloneSymbol(object);
  }
}

var _initCloneByTag = initCloneByTag$1;

var isObject$1 = isObject_1;

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate$1 = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var _baseCreate = baseCreate$1;

var baseCreate = _baseCreate,
    getPrototype = _getPrototype,
    isPrototype = _isPrototype;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject$1(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

var _initCloneObject = initCloneObject$1;

var getTag$2 = _getTag,
    isObjectLike$1 = isObjectLike_1;

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap$1(value) {
  return isObjectLike$1(value) && getTag$2(value) == mapTag$1;
}

var _baseIsMap = baseIsMap$1;

var baseIsMap = _baseIsMap,
    baseUnary$1 = _baseUnary,
    nodeUtil$1 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap$1 = nodeIsMap ? baseUnary$1(nodeIsMap) : baseIsMap;

var isMap_1 = isMap$1;

var getTag$1 = _getTag,
    isObjectLike = isObjectLike_1;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet$1(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

var _baseIsSet = baseIsSet$1;

var baseIsSet = _baseIsSet,
    baseUnary = _baseUnary,
    nodeUtil = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet$1 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet_1 = isSet$1;

var Stack = _Stack,
    arrayEach = _arrayEach,
    assignValue = _assignValue,
    baseAssign = _baseAssign,
    baseAssignIn = _baseAssignIn,
    cloneBuffer = _cloneBuffer.exports,
    copyArray = _copyArray,
    copySymbols = _copySymbols,
    copySymbolsIn = _copySymbolsIn,
    getAllKeys = _getAllKeys,
    getAllKeysIn = _getAllKeysIn,
    getTag = _getTag,
    initCloneArray = _initCloneArray,
    initCloneByTag = _initCloneByTag,
    initCloneObject = _initCloneObject,
    isArray = isArray_1,
    isBuffer = isBuffer$1.exports,
    isMap = isMap_1,
    isObject = isObject_1,
    isSet = isSet_1,
    keys = keys_1,
    keysIn = keysIn_1;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG$1 = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone$1(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG$1,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone$1(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone$1(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

var _baseClone = baseClone$1;

var baseClone = _baseClone;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

var cloneDeep_1 = cloneDeep;

var ea=Object.defineProperty,ta=Object.defineProperties;var oa=Object.getOwnPropertyDescriptors;var ut=Object.getOwnPropertySymbols;var Do=Object.prototype.hasOwnProperty,jo=Object.prototype.propertyIsEnumerable;var Go=(e,t,o)=>t in e?ea(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,n=(e,t)=>{for(var o in t||(t={}))Do.call(t,o)&&Go(e,o,t[o]);if(ut)for(var o of ut(t))jo.call(t,o)&&Go(e,o,t[o]);return e},c=(e,t)=>ta(e,oa(t));var pt=(e,t)=>{var o={};for(var r in e)Do.call(e,r)&&t.indexOf(r)<0&&(o[r]=e[r]);if(e!=null&&ut)for(var r of ut(e))t.indexOf(r)<0&&jo.call(e,r)&&(o[r]=e[r]);return o};var p=(e,t,o)=>new Promise((r,i)=>{var s=u=>{try{d(o.next(u));}catch(m){i(m);}},a=u=>{try{d(o.throw(u));}catch(m){i(m);}},d=u=>u.done?r(u.value):Promise.resolve(u.value).then(s,a);d((o=o.apply(e,t)).next());});var ft={logger:typeof console!="undefined"?console:void 0,WebSocket:typeof WebSocket!="undefined"?WebSocket:void 0},_={log(...e){this.enabled&&(e.push(Date.now()),ft.logger.log("[ActionCable]",...e));}},Ke=()=>new Date().getTime(),mt=e=>(Ke()-e)/1e3,Je=class{constructor(t){this.visibilityDidChange=this.visibilityDidChange.bind(this),this.connection=t,this.reconnectAttempts=0;}start(){this.isRunning()||(this.startedAt=Ke(),delete this.stoppedAt,this.startPolling(),addEventListener("visibilitychange",this.visibilityDidChange),_.log(`ConnectionMonitor started. stale threshold = ${this.constructor.staleThreshold} s`));}stop(){this.isRunning()&&(this.stoppedAt=Ke(),this.stopPolling(),removeEventListener("visibilitychange",this.visibilityDidChange),_.log("ConnectionMonitor stopped"));}isRunning(){return this.startedAt&&!this.stoppedAt}recordPing(){this.pingedAt=Ke();}recordConnect(){this.reconnectAttempts=0,this.recordPing(),delete this.disconnectedAt,_.log("ConnectionMonitor recorded connect");}recordDisconnect(){this.disconnectedAt=Ke(),_.log("ConnectionMonitor recorded disconnect");}startPolling(){this.stopPolling(),this.poll();}stopPolling(){clearTimeout(this.pollTimeout);}poll(){this.pollTimeout=setTimeout(()=>{this.reconnectIfStale(),this.poll();},this.getPollInterval());}getPollInterval(){let{staleThreshold:t,reconnectionBackoffRate:o}=this.constructor,r=Math.pow(1+o,Math.min(this.reconnectAttempts,10)),s=(this.reconnectAttempts===0?1:o)*Math.random();return t*1e3*r*(1+s)}reconnectIfStale(){this.connectionIsStale()&&(_.log(`ConnectionMonitor detected stale connection. reconnectAttempts = ${this.reconnectAttempts}, time stale = ${mt(this.refreshedAt)} s, stale threshold = ${this.constructor.staleThreshold} s`),this.reconnectAttempts++,this.disconnectedRecently()?_.log(`ConnectionMonitor skipping reopening recent disconnect. time disconnected = ${mt(this.disconnectedAt)} s`):(_.log("ConnectionMonitor reopening"),this.connection.reopen()));}get refreshedAt(){return this.pingedAt?this.pingedAt:this.startedAt}connectionIsStale(){return mt(this.refreshedAt)>this.constructor.staleThreshold}disconnectedRecently(){return this.disconnectedAt&&mt(this.disconnectedAt)<this.constructor.staleThreshold}visibilityDidChange(){document.visibilityState==="visible"&&setTimeout(()=>{(this.connectionIsStale()||!this.connection.isOpen())&&(_.log(`ConnectionMonitor reopening stale connection on visibilitychange. visibilityState = ${document.visibilityState}`),this.connection.reopen());},200);}};Je.staleThreshold=6;Je.reconnectionBackoffRate=.15;var ra={message_types:{welcome:"welcome",disconnect:"disconnect",ping:"ping",confirmation:"confirm_subscription",rejection:"reject_subscription"},disconnect_reasons:{unauthorized:"unauthorized",invalid_request:"invalid_request",server_restart:"server_restart",remote:"remote"},default_mount_path:"/cable",protocols:["actioncable-v1-json","actioncable-unsupported"]},{message_types:ze,protocols:Jt}=ra,ia=Jt.slice(0,Jt.length-1),Wo=[].indexOf,Xe=class{constructor(t){this.open=this.open.bind(this),this.consumer=t,this.subscriptions=this.consumer.subscriptions,this.monitor=new Je(this),this.disconnected=!0;}send(t){return this.isOpen()?(this.webSocket.send(JSON.stringify(t)),!0):!1}open(){if(this.isActive())return _.log(`Attempted to open WebSocket, but existing socket is ${this.getState()}`),!1;{let t=[...Jt,...this.consumer.subprotocols||[]];return _.log(`Opening WebSocket, current state is ${this.getState()}, subprotocols: ${t}`),this.webSocket&&this.uninstallEventHandlers(),this.webSocket=new ft.WebSocket(this.consumer.url,t),this.installEventHandlers(),this.monitor.start(),!0}}close({allowReconnect:t}={allowReconnect:!0}){if(t||this.monitor.stop(),this.isOpen())return this.webSocket.close()}reopen(){if(_.log(`Reopening WebSocket, current state is ${this.getState()}`),this.isActive())try{return this.close()}catch(t){_.log("Failed to reopen WebSocket",t);}finally{_.log(`Reopening WebSocket in ${this.constructor.reopenDelay}ms`),setTimeout(this.open,this.constructor.reopenDelay);}else return this.open()}getProtocol(){if(this.webSocket)return this.webSocket.protocol}isOpen(){return this.isState("open")}isActive(){return this.isState("open","connecting")}triedToReconnect(){return this.monitor.reconnectAttempts>0}isProtocolSupported(){return Wo.call(ia,this.getProtocol())>=0}isState(...t){return Wo.call(t,this.getState())>=0}getState(){if(this.webSocket){for(let t in ft.WebSocket)if(ft.WebSocket[t]===this.webSocket.readyState)return t.toLowerCase()}return null}installEventHandlers(){for(let t in this.events){let o=this.events[t].bind(this);this.webSocket[`on${t}`]=o;}}uninstallEventHandlers(){for(let t in this.events)this.webSocket[`on${t}`]=function(){};}};Xe.reopenDelay=500;Xe.prototype.events={message(e){if(!this.isProtocolSupported())return;let{identifier:t,message:o,reason:r,reconnect:i,type:s}=JSON.parse(e.data);switch(s){case ze.welcome:return this.triedToReconnect()&&(this.reconnectAttempted=!0),this.monitor.recordConnect(),this.subscriptions.reload();case ze.disconnect:return _.log(`Disconnecting. Reason: ${r}`),this.close({allowReconnect:i});case ze.ping:return this.monitor.recordPing();case ze.confirmation:return this.subscriptions.confirmSubscription(t),this.reconnectAttempted?(this.reconnectAttempted=!1,this.subscriptions.notify(t,"connected",{reconnected:!0})):this.subscriptions.notify(t,"connected",{reconnected:!1});case ze.rejection:return this.subscriptions.reject(t);default:return this.subscriptions.notify(t,"received",o)}},open(){if(_.log(`WebSocket onopen event, using '${this.getProtocol()}' subprotocol`),this.disconnected=!1,!this.isProtocolSupported())return _.log("Protocol is unsupported. Stopping monitor and disconnecting."),this.close({allowReconnect:!1})},close(e){if(_.log("WebSocket onclose event"),!this.disconnected)return this.disconnected=!0,this.monitor.recordDisconnect(),this.subscriptions.notifyAll("disconnected",{willAttemptReconnect:this.monitor.isRunning()})},error(){_.log("WebSocket onerror event");}};var sa=function(e,t){if(t!=null)for(let o in t){let r=t[o];e[o]=r;}return e},Xt=class{constructor(t,o={},r){this.consumer=t,this.identifier=JSON.stringify(o),sa(this,r);}perform(t,o={}){return o.action=t,this.send(o)}send(t){return this.consumer.send({command:"message",identifier:this.identifier,data:JSON.stringify(t)})}unsubscribe(){return this.consumer.subscriptions.remove(this)}},Zt=class{constructor(t){this.subscriptions=t,this.pendingSubscriptions=[];}guarantee(t){this.pendingSubscriptions.indexOf(t)==-1?(_.log(`SubscriptionGuarantor guaranteeing ${t.identifier}`),this.pendingSubscriptions.push(t)):_.log(`SubscriptionGuarantor already guaranteeing ${t.identifier}`),this.startGuaranteeing();}forget(t){_.log(`SubscriptionGuarantor forgetting ${t.identifier}`),this.pendingSubscriptions=this.pendingSubscriptions.filter(o=>o!==t);}startGuaranteeing(){this.stopGuaranteeing(),this.retrySubscribing();}stopGuaranteeing(){clearTimeout(this.retryTimeout);}retrySubscribing(){this.retryTimeout=setTimeout(()=>{this.subscriptions&&typeof this.subscriptions.subscribe=="function"&&this.pendingSubscriptions.map(t=>{_.log(`SubscriptionGuarantor resubscribing ${t.identifier}`),this.subscriptions.subscribe(t);});},500);}},eo=class{constructor(t){this.consumer=t,this.guarantor=new Zt(this),this.subscriptions=[];}create(t,o){let r=t,i=typeof r=="object"?r:{channel:r},s=new Xt(this.consumer,i,o);return this.add(s)}add(t){return this.subscriptions.push(t),this.consumer.ensureActiveConnection(),this.notify(t,"initialized"),this.subscribe(t),t}remove(t){return this.forget(t),this.findAll(t.identifier).length||this.sendCommand(t,"unsubscribe"),t}reject(t){return this.findAll(t).map(o=>(this.forget(o),this.notify(o,"rejected"),o))}forget(t){return this.guarantor.forget(t),this.subscriptions=this.subscriptions.filter(o=>o!==t),t}findAll(t){return this.subscriptions.filter(o=>o.identifier===t)}reload(){return this.subscriptions.map(t=>this.subscribe(t))}notifyAll(t,...o){return this.subscriptions.map(r=>this.notify(r,t,...o))}notify(t,o,...r){let i;return typeof t=="string"?i=this.findAll(t):i=[t],i.map(s=>typeof s[o]=="function"?s[o](...r):void 0)}subscribe(t){this.sendCommand(t,"subscribe")&&this.guarantor.guarantee(t);}confirmSubscription(t){_.log(`Subscription confirmed ${t}`),this.findAll(t).map(o=>this.guarantor.forget(o));}sendCommand(t,o){let{identifier:r}=t;return this.consumer.send({command:o,identifier:r})}},St=class{constructor(t){this._url=t,this.subscriptions=new eo(this),this.connection=new Xe(this),this.subprotocols=[];}get url(){return na(this._url)}send(t){return this.connection.send(t)}connect(){return this.connection.open()}disconnect(){return this.connection.close({allowReconnect:!1})}ensureActiveConnection(){if(!this.connection.isActive())return this.connection.open()}addSubProtocol(t){this.subprotocols=[...this.subprotocols,t];}};function na(e){if(typeof e=="function"&&(e=e()),e&&!/^wss?:/i.test(e)){let t=document.createElement("a");return t.href=e,t.href=t.href,t.protocol=t.protocol.replace("http","ws"),t.href}else return e}var aa=Object.defineProperty,$o=Object.getOwnPropertySymbols,da=Object.prototype.hasOwnProperty,ca=Object.prototype.propertyIsEnumerable,Ho=(e,t,o)=>t in e?aa(e,t,{enumerable:!0,configurable:!0,writable:!0,value:o}):e[t]=o,Yo=(e,t)=>{for(var o in t||(t={}))da.call(t,o)&&Ho(e,o,t[o]);if($o)for(var o of $o(t))ca.call(t,o)&&Ho(e,o,t[o]);return e},la=class zo extends Error{constructor(t){super(t),this.name="MissingConfigError",Object.setPrototypeOf(this,zo.prototype);}},ua=class Ko extends Error{constructor(t){super(t),this.name="MissingTokenError",Object.setPrototypeOf(this,Ko.prototype);}},pa=class Jo extends Error{constructor(t){super(t),this.name="MissingWebsocketUriError",Object.setPrototypeOf(this,Jo.prototype);}},to=()=>{},Xo=class{constructor(e){this.timeout=6e4,this._socketConnected=!1,this.handleConnected=t=>(this._socketConnected||(this._socketConnected=!0),t),this.handleDisconnected=(t,o)=>(this._socketConnected&&(this._socketConnected=!1,setTimeout(()=>{o&&o(),this.socketTimeOut();},this.timeout)),t),this._config=e;}get id(){var e,t;return (t=(e=this._config)==null?void 0:e.id)!=null?t:""}start(){return this.validate(),this.connect()}validate(){if(!this._config)throw new la("config is required");if(!this._config.token)throw new ua("config.token is required");if(!this._config.wsBaseUri)throw new pa("config.wsBaseUri is required")}connect(){let e=this.cable;return e&&e!==this.cable?(this.cable=e,this.cable):(e=new St(`${this._config.wsBaseUri}?token=${this._config.token}`),this.cable=e,e.ensureActiveConnection(),this.cable)}getHandlers(e){var t,o,r;let i={received:(t=e==null?void 0:e.received)!=null?t:to,connected:(o=e==null?void 0:e.connected)!=null?o:to,disconnected:(r=e==null?void 0:e.disconnected)!=null?r:to},s=this.handleDisconnected(i.disconnected),a=this.handleConnected(i.connected);return {received:i.received,connected:a,disconnected:s}}subscribe(e,t,o){let r=this.cable;if(!r)return;t?t=Yo({token:this._config.token},t):t={token:this._config.token};let i=Yo({channel:e},t),s=this.getHandlers(o);return r.subscriptions.create(i,s)}disconnect(e=!0){return this.cleanup(this.cable,e)}cleanup(e,t){e&&e.disconnect(),t&&(this.cable=void 0);}socketTimeOut(){this._socketConnected||this.cleanup(this.cable,!1);}};var gt=createAction("answers/Push"),lm=createAction("answersQueue/Check"),Pe=createAction("queues/QueueAnswer");var Zo=createAction("auth/NotifyAuthFailed");var er=createAction("quoteResources/Timeout",()=>({payload:{updatedAt:new Date}}));var or=createAction("reset/ResetApplication"),K=createAction("reset/ResetStore");var rr=createAction("selectVehicle/Reset");var Ze=createAction("websocket/ConnectionEvent"),At=createAction("websocket/SetActiveSocketId"),Q=createAction("websocket/ReceiveBatchWebsocket");var Aa=e=>e.application,se=createSelector([Aa],e=>e.questionSets),E=createSelector(se,e=>e.list),io=createSelector(se,e=>e.active),ir=createSelector(se,e=>e.activeAnswerId),T=createSelector(E,io,(e,t)=>e.find(o=>o.question_set_id===t)),sr=createSelector(se,e=>e.idOfNextActiveQuestionSetNotInState);createSelector(T,e=>{var t;return (t=e==null?void 0:e.question_set)==null?void 0:t.code});createSelector(E,e=>e.filter(t=>t.is_active&&t.answers.some(o=>o.active)));createSelector(E,e=>e.filter(t=>t.is_active&&t.is_completed));var nr=createSelector(E,e=>e.filter(t=>t.is_active&&!t.is_completed));createSelector([E,(e,t)=>t],(e,t)=>e.find(o=>o.id===t));var Fm=createSelector([E,(e,t)=>t],(e,t)=>Xn$1(e,t));createSelector(se,e=>e.completedQuestionSetAnswerHasChanged);var Vm=createSelector(se,e=>e.parentQuestionSets),Mm=createSelector([se,(e,t)=>t],(e,t)=>{var r,i;let o=n({},t);return (r=e.pendingActiveAnswerUpdate)!=null&&r.question.reference_type&&o[e.pendingActiveAnswerUpdate.question.reference_type]&&e.pendingActiveAnswerUpdate.id===o[e.pendingActiveAnswerUpdate.question.reference_type].id&&(o[(i=e.pendingActiveAnswerUpdate)==null?void 0:i.question.reference_type]=e.pendingActiveAnswerUpdate),o});createSelector([T,(e,t)=>t],(e,t)=>e==null?void 0:e.answers.find(o=>o.id===t));var Ia=createSelector([T,(e,t)=>t],(e,t)=>{var o,r;return (r=(o=e==null?void 0:e.answers)==null?void 0:o.filter(i=>(i==null?void 0:i.answer_pool_id)===t))!=null?r:[]}),ha=createSelector([T,(e,t)=>t],(e,t)=>{var o,r;return (r=(o=e==null?void 0:e.answers)==null?void 0:o.filter(i=>(i==null?void 0:i.question.question_group_id)===t))!=null?r:[]}),jm=createSelector([ha,Ia,ir,(e,t)=>t],(e,t,o)=>!!(e!=null&&e.find(r=>(r==null?void 0:r.id)===o))||!!(t!=null&&t.find(r=>(r==null?void 0:r.id)===o))),Wm=createSelector([T,(e,t)=>t],(e,t)=>{var o;return (o=e==null?void 0:e.answers.filter(r=>r.question.question_group_id===t.groupId&&r.answer_pool_id===t.poolId))!=null?o:[]});createSelector([E,(e,t)=>t],(e,t)=>t instanceof RegExp?e.flatMap(o=>o.answers).filter(o=>t.test(o.question.code)):e.flatMap(o=>o.answers).filter(o=>o.question.code.includes(t)));createSelector([E,(e,t)=>t],(e,t)=>t instanceof RegExp?e.flatMap(o=>o.answers).filter(o=>{var r;return t.test((r=o.question.reference_type)!=null?r:"")}):e.flatMap(o=>o.answers).filter(o=>o.question.code.includes(t)));createSelector([E],e=>{var r,i;let t=e.flatMap(s=>s.answers).find(s=>s.question.reference_type==="business_class"),o=(i=(r=t==null?void 0:t.question)==null?void 0:r.choices)==null?void 0:i.find(s=>s.id===(t==null?void 0:t.choice_id));return o==null?void 0:o.value});var ar=e=>e.application,M=createSelector(ar,e=>e.form),Jm=createSelector(M,e=>e.id);createSelector(M,e=>{var t;return (t=e.features)!=null?t:[]});createSelector(M,e=>{var t;return (t=e.reference_id)!=null?t:""});createSelector(M,e=>e.percent_completed);createSelector(ar,e=>e.progress.meta.form.forwardProgressPercent);var of=createSelector(M,e=>e.state);createSelector(M,e=>({source:e.source,metadata:e.source_metadata}));var dr=createSelector(M,e=>e.appetite),_a=e=>e.application.form.buckets;createSelector(_a,M,(e,t)=>e.find(o=>o.id===t.current_bucket_id));createSelector(M,e=>e.storefront_active_enrolled_product_codes);createSelector(dr,e=>{let t=xa(e);return wa(t)});function xa(e){return e.flatMap(t=>t.carriers.filter(o=>o.is_enrolled))}function wa(e){let t=new Set;return e.reduce((o,r)=>(t.has(r.tenant_id)||(t.add(r.tenant_id),o.push(r)),o),[])}var w=e=>e.auth;createSelector(w,e=>e==null?void 0:e.refreshCount);var so=createSelector(w,e=>e==null?void 0:e.user);createSelector(w,e=>e==null?void 0:e.token);createSelector(w,e=>{var t;return (t=e==null?void 0:e.expiresAt)!=null?t:Date.now()-1});var va=createSelector(w,e=>{var t;return (t=e==null?void 0:e.expiresAt)!=null?t:Date.now()-1}),cr=createSelector(w,e=>e==null?void 0:e.userId);createSelector(w,e=>e==null?void 0:e.email);createSelector(w,e=>e==null?void 0:e.name);createSelector(w,e=>e==null?void 0:e.firstName);createSelector(w,e=>e==null?void 0:e.lastName);createSelector(w,e=>e==null?void 0:e.tenantLogoUrl);createSelector(w,e=>e==null?void 0:e.tenantName);createSelector(w,e=>e==null?void 0:e.tenantTheme);createSelector(w,e=>e==null?void 0:e.terminalTheme);createSelector(so,e=>{var t,o;return (o=(t=e==null?void 0:e.extra)==null?void 0:t.raw_info)==null?void 0:o.tenants});var lr=createSelector(va,e=>e>Date.now());var pr=e=>e.application.carriersProducts;createSelector(pr,e=>e.filter(t=>t.carrier.online));createSelector(pr,e=>e.filter(t=>!t.carrier.online));var Of=e=>e.status.remote.carriersProducts.state;var Qa=e=>e.application.choices,Tf=createSelector([Qa,(e,t)=>t],(e,t)=>{var o,r;return (r=(o=e[t])==null?void 0:o.list)!=null?r:[]});var Qe=e=>e.config,mr=createSelector([Qe,w],(e,t)=>({env:e.env,uri:e.uri,token:t.token}));createSelector([Qe,w],(e,t)=>({env:e.env,uri:e.hookshotUri,token:t.token}));createSelector(Qe,e=>e.googleApiToken);createSelector(Qe,e=>e.cableToken);var Nf=createSelector(Qe,e=>e.debug||!1),ne=createSelector(Qe,e=>e.options),Uf=createSelector(ne,e=>!!e.enableAutocomplete),Gf=createSelector(ne,e=>!!e.enableDetailedRelevanceChips),Df=createSelector(ne,e=>!!e.enableQuestionSetNavigation),jf=createSelector(ne,e=>!!e.showParentQuestionSetsInNavigation),Wf=createSelector(ne,e=>!!e.enableAddressValidation),$f=createSelector(ne,e=>e.addressValidationOptions),Hf=createSelector(ne,e=>!!e.shouldQuoteCardRenderSupplierLogos);var et=e=>e.application.form.eligible_carriers_products;createSelector(et,e=>no(e));var Sr=createSelector(et,e=>ao(e)),It=createSelector(et,e=>e.filter(t=>t.market?t.market===ee$2.BP_QUOTABLE:t.carrier.online));createSelector(It,e=>no(e));var gr=createSelector(It,e=>ao(e)),ht=createSelector(et,e=>e.filter(t=>t.market?t.market===ee$2.OFFLINE:!t.carrier.online));createSelector(ht,e=>no(e));createSelector(ht,e=>ao(e));createSelector([et,(e,t)=>t],(e,t)=>e.reduce((o,r)=>r.carrier.id===t?[...o,r.product]:o,[]));function no(e){return Object.values(e.reduce((t,o)=>c(n({},t),{[o.carrier.id]:o.carrier}),{}))}function ao(e){let t=e.reduce((o,r)=>{let i=o.get(r.carrier.id);return i?i.products.push(r.product):o.set(r.carrier.id,c(n({},r.carrier),{products:[r.product]})),o},new Map);return Array.from(t.values())}var ya=e=>e.application;createSelector(ya,e=>e.enrollments);var _t=e=>e.application.form,Ir=e=>e.status.remote,SS=createSelector([_t],e=>e.locked);createSelector([_t],e=>e.taken_over);var AS=createSelector([_t],e=>e.cloned);createSelector([_t],e=>e.inactive);var hS=createSelector([Ir],e=>e.application.form===R$1.Loaded),hr=createSelector([Ir],e=>e.application.form===R$1.Loading);var Oe=e=>e.application.form.messages||[];createSelector([Oe,(e,t)=>t],(e,t)=>e.filter(o=>o.component===ce$1.Answer&&o.metadata.answer_id===t&&o.location!==fe$2.Question));createSelector([Oe,T],(e,t)=>{let o=(t==null?void 0:t.answers.map(r=>r.id))||[];return !e.length||!o.length?[]:e.filter(r=>r.component===ce$1.Answer&&r.location!==fe$2.Question&&o.includes(r.metadata.answer_id||""))});createSelector([Oe,(e,t)=>t],(e,t)=>e.filter(o=>o.component===ce$1.Answer&&o.metadata.answer_id===t&&o.location===fe$2.Question));createSelector([Oe,(e,t)=>t],(e,t)=>e.filter(o=>o.component===ce$1.QuoteRequest&&o.metadata.quote_request_id===t));var RS=createSelector(Oe,e=>e.filter(t=>t.component===ce$1.Application));createSelector(Oe,e=>e.filter(t=>t.component===ce$1.Application&&t.location===fe$2.QuotePresentation));var Oa=e=>e.application.pendingProcesses,qS=createSelector(Oa,io,(e,t)=>e.some(o=>o.question_set_id===t&&(o.state===te$1.Pending||o.state===te$1.Queued||o.state===te$1.Executing)));createSelector(w,e=>e.permissions);var DS=createSelector([cr,M],(e,t)=>t!=null&&e===t.owner_id),jS=createSelector([so,(e,t)=>n({},t)],(e,{permission:t,object:o,action:r})=>{let i=Xt$1(t);return Zt$1({user:e,object:o,action:r!=null?r:i.action,model:i.model||t})});createSelector(w,e=>!!e.options.impersonated);createSelector(T,(e,t)=>t,(e,t)=>{var o;if(e)return (o=e.question_set)==null?void 0:o.question_pools.find(r=>r.parent_question_id===t.question.id)});var ae=e=>e.application.quotes,La=e=>e.application.siblingQuotes;createSelector([La],e=>e);var eg=createSelector([ae,(e,t)=>t],(e,t)=>e.find(o=>o.id===t));createSelector([ae,(e,t)=>t],(e,t)=>e.filter(o=>o.request_status===t));createSelector([ae,(e,t)=>t],(e,t)=>e.filter(o=>o.products.includes(t)));createSelector([ae,(e,t)=>t],(e,t)=>e.filter(o=>o.products.filter(r=>r.id===t).length));createSelector([ae,(e,t)=>t],(e,t)=>e.filter(o=>o.products.filter(r=>r.name===t).length));var Va=e=>e.status.remote.quotes.state===R$1.Loading;createSelector(hr,Va,(e,t)=>e||!t);var Da=e=>e.application,Cr=createSelector([Da],e=>e.form.real_time_eligibility.carriers||[]),ja=createSelector([Cr],e=>e.filter(t=>t.eligible));createSelector([Cr],e=>e.filter(t=>!t.eligible));var Wa=createSelector([E],e=>Rt$1(e.flatMap(t=>t.answers),v$2.LinesOfBusiness));createSelector([Wa],e=>{let t=e.length?C$1(e[0]):null;return Array.isArray(t)?t:t?[t]:[]});var xr=(e,t,o=0)=>{let r={active:!0,annual_price:"",application_form_id:"",bindable:!0,calls_to_action:[],carrier:{code:e.code,id:e.id,logo_url:e.logo_url,logo_url_small:e.logo_url_small,name:e.name,online:e.online,labels:e.labels,opt_in_required:e.opt_in_required,opted_in:e.opted_in},consumer_selected:!0,coverage:{disclaimer:"",limit_and_deductible:[],limit_and_deductible_default:[]},created_at:new Date().toISOString(),customizable:!1,downpayment:"",effective_date:null,expired:!1,stale:!1,finished_at:new Date().toISOString(),focused:!1,id:e.id,monthly_price:"",number_of_installments:0,online:e.online||!1,order:o,owner_id:"",permitted_to_bind:!0,plans:null,policy:null,preferred:!1,price_details:{disclaimer_html:null,fees:[],new_total_premium:null,premiums:[],taxes:[]},products:e.products.map(i=>c(n({},i),{from_name:null})),quote_number:"",recommended:!1,request_status:t,retrieve_url:"",semiannual_price:"",selected:!1,started_at:new Date().toISOString(),surcharge:0,tenant_id:"",translated_messages:[],updated_at:new Date().toISOString(),actions:[],attachments:[],supplier_code:null,supplier_name:null,supplier_logo_url:null,supplier_logo_url_full:null};return c(n({},r),{quotes:[r]})},$a=e=>{var t;return (t=(e==null?void 0:e.opt_in_required)&&!(e!=null&&e.opted_in))!=null?t:!1},Ha=(e,t)=>{let o=t.some(r=>r.question_set.tenant_id===(e==null?void 0:e.id));return $a(e)&&!o},Ya="not_opted_in",za="incomplete_question_set",Ka=createSelector(nr,gr,(e,t)=>e.reduce((o,r)=>{let i=t.find(s=>s.id===r.question_set.tenant_id);return [...o,...i?[xr(i,za,null)]:[]]},[])),Ja=(e=[])=>{let t=[ie$2.NON_ADMITTED,ie$2.ADDITIONAL_MARKET];return e.some(o=>t.includes(o))},Xa=createSelector(Sr,e=>e.filter(t=>Ja(t.labels))),Za=createSelector(Xa,E,ja,(e,t,o)=>e.filter(r=>Ha(r,t)).map(r=>{let i=Array.from(new Map(r.products.map(u=>[u.id,u])).values()),s=o.find(u=>u.id===r.id),a=i.filter(u=>s==null?void 0:s.products.some(m=>m.name===u.name&&m.market===ee$2.BP_QUOTABLE)),d=c(n({},r),{products:a});return xr(d,Ya)}).filter(r=>!!r.products.length)),ed=createSelector(ht,It,(e,t)=>e.filter(o=>!t.some(r=>r.carrier.id===o.carrier.id&&r.product.id===o.product.id)).map(o=>{let r={active:!0,annual_price:"",application_form_id:o.application_form_id,bindable:!0,calls_to_action:[],carrier:o.carrier,consumer_selected:!0,coverage:{disclaimer:"",limit_and_deductible:[],limit_and_deductible_default:[]},created_at:new Date().toISOString(),customizable:!1,downpayment:"",effective_date:null,expired:!1,stale:!1,finished_at:new Date().toISOString(),focused:!1,id:o.carriers_product_id,monthly_price:"",number_of_installments:0,online:!1,order:0,owner_id:"",permitted_to_bind:!0,plans:null,policy:null,preferred:!1,price_details:{disclaimer_html:null,fees:[],new_total_premium:null,premiums:[],taxes:[]},products:[c(n({},o.product),{from_name:null})],quote_number:"",recommended:!1,request_status:E$2.referral,retrieve_url:"",semiannual_price:"",selected:!1,started_at:new Date().toISOString(),surcharge:0,tenant_id:"",translated_messages:[],updated_at:new Date().toISOString(),actions:[],attachments:[],supplier_code:null,supplier_name:null,supplier_logo_url:null,supplier_logo_url_full:null};return c(n({},r),{quotes:[r]})}));createSelector(ae,Ka,Za,ed,(e,t,o,r)=>[...e||[],...t||[],...o||[],...r||[]]);var uo=e=>e.application.refilters;createSelector([uo,(e,t)=>t],(e,t)=>{var o,r;return (r=(o=e[t])==null?void 0:o.list)!=null?r:[]});createSelector([uo,(e,t)=>t],(e,t)=>{var o,r;return (r=(o=e[t])==null?void 0:o.list.filter(i=>i.value===null))!=null?r:[]});createSelector([uo,(e,t)=>t],(e,t)=>{var o,r;return (r=(o=e[t])==null?void 0:o.list.filter(i=>i.value!==null))!=null?r:[]});var Eg=e=>e.status.remote.answers.state,Tg=e=>e.status.remote.answers.map;var Fg=e=>e.status.remote.application.form;var vr=e=>e.status.remote,Mg=createSelector(vr,e=>e.questionPools.state);createSelector(vr,(e,t)=>t,(e,t)=>e.questionPools.map[t]);var Qr=e=>e.status.remote,jg=createSelector(Qr,e=>e.questionSets.state),kr=createSelector(Qr,e=>e.questionSets.map);createSelector(kr,T,sr,(e,t,o)=>o?!0:t?e[t.id]===R$1.Loading:!1);createSelector(kr,T,(e,t)=>t,(e,t,o)=>t?e[o]===R$1.Loading:!1);var Hg=e=>e.application.questionSets.lockQuestionSet;var od=e=>e.status.remote,Kg=createSelector(od,e=>e.quotes.state);var j=e=>e.status.local;createSelector(j,e=>e.health);createSelector(j,e=>e.state);createSelector(j,e=>e.state===u$1.Loading);createSelector(j,e=>e.config===u$1.Configured);createSelector(j,e=>e.auth===u$1.Configured);var pA=createSelector(j,e=>e.user===u$1.Configured);createSelector(j,e=>e.auth===u$1.Configured);createSelector(j,e=>e.auth===u$1.Configured&&e.user===u$1.Configured);createSelector(j,e=>e.auth===u$1.Configured&&e.config===u$1.Configured&&e.user===u$1.Configured);createSelector(j,e=>e.socket);var rd=e=>e.viewState,X=createSelector(rd,e=>e.vehicleOptions);createSelector([(e,t)=>({state:e,questionGroupId:t})],({state:e,questionGroupId:t})=>({configurations:md(e,t),makes:ud(e,t),models:pd(e,t),selection:fd(e,t),vin:Sd(e,t),years:ld(e,t)}));var id=createSelector(X,e=>e.years),sd=createSelector(X,e=>e.makes),nd=createSelector(X,e=>e.models),ad=createSelector(X,e=>e.configurations),dd=createSelector(X,e=>e.selection),cd=createSelector(X,e=>e.vin),ld=createSelector([id,(e,t)=>t],(e,t)=>e[t]),ud=createSelector([sd,(e,t)=>t],(e,t)=>e[t]),pd=createSelector([nd,(e,t)=>t],(e,t)=>e[t]),md=createSelector([ad,(e,t)=>t],(e,t)=>e[t]),fd=createSelector([dd,(e,t)=>t],(e,t)=>e[t]),Sd=createSelector([cd,(e,t)=>t],(e,t)=>e[t]),wA=createSelector([X,(e,t)=>t],(e,t)=>{var d,u,m,I,F,ct,He,z,xe,we,ve,lt,N,Ye;let o=e.selection,r={year:(u=(d=o==null?void 0:o[t])==null?void 0:d.yearId)!=null?u:"",make:"",model:"",configuration:""},i=(m=o[t])==null?void 0:m.makeId;i&&(r.make=(ct=(F=(I=e.makes)==null?void 0:I[t])==null?void 0:F[i])!=null?ct:"");let s=(He=o[t])==null?void 0:He.modelId;s&&(r.model=(we=(xe=(z=e.models)==null?void 0:z[t])==null?void 0:xe[s])!=null?we:"");let a=(ve=o[t])==null?void 0:ve.configurationId;return a&&(r.configuration=(Ye=(N=(lt=e.configurations)==null?void 0:lt[t])==null?void 0:N[a])!=null?Ye:""),r}),vA=createSelector([X,(e,t)=>t],(e,t)=>e.selection[t]);var gd=e=>e.status.remote,Ee=createSelector(gd,e=>e.vehicles);createSelector(Ee,e=>e.configurations);createSelector(Ee,e=>e.makes);createSelector(Ee,e=>e.models);var Ad=createSelector(Ee,e=>e.selection),Id=createSelector(Ee,e=>e.vins);createSelector(Ee,e=>e.years);var bA=createSelector([Ad,(e,t)=>t],(e,t)=>e[t]),EA=createSelector([Id,(e,t)=>t],(e,t)=>e[t]);var v=e=>e.viewState,hd=createSelector([v],e=>e.features),yr=createSelector([v],e=>e.quotes);createSelector([v],e=>e.addressValidation);var Rr=createSelector([v,(e,t)=>t],(e,t)=>e.addressValidation.validations[t]),MA=createSelector([v,(e,t)=>t],(e,t)=>t?!!e.addressValidation.validations[t]:null),BA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return (o=e.addressValidation.validations[t])==null?void 0:o.verdict}),NA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return ((o=e.addressValidation.validations[t])==null?void 0:o.validationStatus)===_e$1.COMPLETED}),UA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return ((o=e.addressValidation.validations[t])==null?void 0:o.validationStatus)===_e$1.VALIDATION_ERROR}),GA=createSelector([v,(e,t)=>t],(e,t)=>{var o,r,i,s;return ((o=e.addressValidation.validations[t])==null?void 0:o.validationStatus)===_e$1.VALIDATED||((r=e.addressValidation.validations[t])==null?void 0:r.validationStatus)===_e$1.COMPLETED||((i=e.addressValidation.validations[t])==null?void 0:i.validationStatus)===_e$1.VALIDATION_ERROR||((s=e.addressValidation.validations[t])==null?void 0:s.validationStatus)===_e$1.PROCEED_NEXT}),DA=createSelector([v],e=>Object.entries(e.addressValidation.validations).filter(([,t])=>t.validationStatus===_e$1.REQUIRED).map(([t])=>t)),jA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return ((o=e.addressValidation.validations[t])==null?void 0:o.validationStatus)===_e$1.READY_TO_VALIDATE}),WA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return (o=e.addressValidation.validations[t])==null?void 0:o.validationStatus}),$A=createSelector([v,(e,t)=>t],(e,t)=>t&&!!Object.entries(e.addressValidation.validations).filter(([o,r])=>(t.answers.map(i=>i.answer_pool_id).includes(o)||t.question_set.question_groups.map(i=>i.id).includes(o))&&r.validationStatus===_e$1.VALIDATED).length),HA=createSelector([v],e=>Object.fromEntries(Object.entries(e.addressValidation.validations).map(([t,o])=>[t,o.validationStatus]))),YA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return (o=e.addressValidation.validations[t])==null?void 0:o.address}),zA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return (o=e.addressValidation.validations[t])==null?void 0:o.attempt}),KA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return (o=e.addressValidation.validations[t])==null?void 0:o.stagedAnswers}),JA=createSelector([v,(e,t)=>t],(e,t)=>{var o;return (o=e.addressValidation.validations[t])==null?void 0:o.originalAddress}),XA=createSelector([v],e=>e.addressValidation.shouldOverrideValidationTrigger),ZA=createSelector([hd,(e,t)=>t],(e,t)=>e.list.includes(t));createSelector([yr],e=>e.filteredOnlineQuotes);createSelector([yr],e=>e.filteredOfflineQuotes);function xd(e){return p(this,null,function*(){var t,o;return (o=(t=window==null?void 0:window.BpSdk)==null?void 0:t.refreshGuestSetup(e))!=null?o:Promise.reject("SDK must be configured before loading a guest application")})}var pe="applicationForms",ot=createAsyncThunk(`${pe}/LoadOne`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield T$1.getApplicationForm(e.id,e.config)).parsedBody}catch(i){let s=new L("Error loading app form",i);throw nr$1(s),t(s),s}})),me=createAsyncThunk(`${pe}/LoadLatestOne`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield T$1.getLatestApplicationForm(e.id,e.config)).parsedBody}catch(i){let s=new L("Error loading app form",i);throw nr$1(s),t(s),s}})),de=createAsyncThunk(`${pe}/LoadOneFromToken`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){var i;try{let s=yield T$1.getApplicationFormFromToken(e.token_id,e);if(s.parsedBody)return k(j$2.cableToken,(i=s.parsedBody.application_form)==null?void 0:i.cable_token),s.parsedBody.application_form;throw new L("Application form does not exist on HTTP response body")}catch(s){let a=new L("Error loading app form from token",s);throw nr$1(a),t(a),a}})),Pt=createAsyncThunk(`${pe}/LoadGuest`,(i,s)=>p(void 0,[i,s],function*(e,{rejectWithValue:t,dispatch:o,getState:r}){try{let a=x$2(j$2.token),d=x$2(j$2.cableToken),u=r();if(a&&d&&lr(u))return o(de(c(n({},e),{token:a,token_id:d})));let{parsedBody:I}=yield T$1.getTokenForAuthGuestFlow(e);return yield or$1(I.token,I.token_id),yield xd(n(n({},u.config),e)),o(de(c(n({},e),{token:x$2(j$2.token),token_id:x$2(j$2.cableToken)})))}catch(a){let d=new L("Error loading guest application form",a);throw nr$1(d),t(d)}})),rt=createAsyncThunk(`${pe}/Clone`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield T$1.cloneApplicationForm(e.appFormId,e.config)).parsedBody}catch(i){let s=new L("Error cloning application form",i);throw nr$1(s),t(s),s}})),it=createAsyncThunk(`${pe}/CreateAndLoad`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield T$1.createApplicationForm(e.data,e.config)).parsedBody}catch(i){let s=new L("Error loading app form",i);throw nr$1(s),t(s),s}})),Or=createAsyncThunk(`${pe}/GetEligibilityResults`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield T$1.getEligibilityResults(e.appId,e.config)).parsedBody}catch(i){let s=new L("Error getting eligibility results",i);throw nr$1(s),t(s),s}}));var po=[or,K],l=[...po,ot.pending,me.pending,de.pending,rt.pending,it.pending],br=[ot.pending,me.pending,de.pending,rt.pending,it.pending],h=[ot.fulfilled,me.fulfilled,de.fulfilled,rt.fulfilled,it.fulfilled],Qt=[ot.rejected,me.rejected,de.rejected,rt.rejected,it.rejected];var mo=n({},fa),Br=createSlice({name:"form",initialState:mo,reducers:{handleMessage:(e,{payload:t})=>Tr(e,t),receiveAppetite:(e,{payload:t})=>Lr(e,t),receiveApplicationForm:(e,{payload:t})=>Fr(e,t),receiveApplicationFormProgress:(e,{payload:t})=>qr(e,t),receiveCarrierProducts:(e,{payload:t})=>Vr(e,t),receiveRealTimeEligibility:(e,{payload:t})=>Mr(e,t)},extraReducers:e=>{e.addCase(Or.fulfilled,(t,{payload:o})=>{y(o,t.eligible_carriers_products)&&(t.eligible_carriers_products=o);}).addCase(Q,(t,{payload:o})=>{let r=n({},t);return o.events.forEach(i=>{switch(i.event){case xe$1.Message:r=Tr(r,i.data);break;case xe$1.Appetite:r=Lr(r,i.data);break;case xe$1.ApplicationForm:r=Fr(r,i.data);break;case xe$1.ApplicationFormPercentCompleted:r=qr(r,i.data);break;case xe$1.CarrierProducts:r=Vr(r,i.data);break;case xe$1.RealTimeEligibility:r=Mr(r,i.data);break}}),r}).addMatcher(isAnyOf(...l),t=>n({},mo)).addMatcher(isAnyOf(...h),(t,{payload:o})=>{let r=Ht(o,Object.keys(mo));return n(n({},t),r)});}}),Tr=(e,t)=>{let o=[...e.messages],r=o.findIndex(i=>i.id===t.id);if(r===-1)o=t.active?[...e.messages,t]:[...e.messages];else {let i=o[r],s=new Date(i.updated_at);new Date(t.updated_at)>s&&(t.active?o.splice(r,1,t):o.splice(r,1));}return o.sort((i,s)=>Tt$1(i.priority,s.priority)),c(n({},e),{messages:o})},Lr=(e,t)=>y(e.appetite,t.appetite)?c(n({},e),{appetite:t.appetite}):e,Fr=(e,t)=>{var i;let o=new Date(e.updated_at);return new Date(t.updated_at)>o?c(n({},e),{allowed_carrier_ids:t.allowed_carrier_ids,appetite:t.appetite,buckets:t.buckets,cloned:t.cloned,copy:(i=t==null?void 0:t.copy)!=null?i:!1,completed_at:t.completed_at,coverage_start_date:t.coverage_start_date,current_bucket_id:t.current_bucket_id,deleted_at:t.deleted_at,features:t.features,finished_quote_requests_count:t.finished_quote_requests_count,labels:t.labels,locked:t.locked,originating_copy_id:t.originating_copy_id,quote_requests_count:t.quote_requests_count,state:t.state,updated_at:t.updated_at,taken_over:t.taken_over,sent_to_wholesaler_at:t.sent_to_wholesaler_at,received_by_wholesaler_at:t.received_by_wholesaler_at,source:t.source,source_metadata:t.source_metadata,storefront_active_enrolled_product_codes:t.storefront_active_enrolled_product_codes,percent_completed:t.percent_completed,real_time_eligibility:t.real_time_eligibility,wholesaler_preferred_quotes:t.wholesaler_preferred_quotes}):e},qr=(e,t)=>(t.percent_completed!==e.percent_completed&&(e.percent_completed=t.percent_completed),e),Vr=(e,t)=>(y(t,e.eligible_carriers_products)&&(e.eligible_carriers_products=t),e),Mr=(e,t)=>(y(t,e.real_time_eligibility)&&(e.real_time_eligibility=t),e),{handleMessage:Le,receiveAppetite:Nr,receiveApplicationForm:ee,receiveApplicationFormProgress:yt,receiveCarrierProducts:Rt,receiveRealTimeEligibility:Ur}=Br.actions,Gr=Br;var Rd=[],jr=createSlice({name:"notifications",initialState:Rd,reducers:{addNewNotification:(e,{payload:t})=>{if(!t)return e;e.push(n({id:ht$1(8)},t));},removeNotification:(e,{payload:t})=>{if(!t)return e;let o=e.findIndex(r=>r.id===t.id);o>-1&&e.splice(o,1);}},extraReducers:e=>{e.addCase(Q,(t,{payload:o})=>(o.events.forEach(r=>{r.event===xe$1.Notification&&t.push(n({id:ht$1(8)},r.data));}),t));}}),{addNewNotification:Wr,removeNotification:Ih}=jr.actions,$r=jr;var Ed=[],Kr=createSlice({name:"pendingProcesses",initialState:Ed,reducers:{receivedApplicationFormPendingProcess:(e,{payload:t})=>{Yr(e,t);}},extraReducers:e=>{e.addCase(ee,(t,{payload:o})=>zr(t,o)).addCase(Q,(t,{payload:o})=>{let r=[...t];return o.events.forEach(i=>{switch(i.event){case xe$1.ApplicationFormProcess:r=Yr(r,i.data);break;case xe$1.ApplicationForm:r=zr(r,i.data);break}}),r}),e.addMatcher(isAnyOf(...h),(t,{payload:o})=>{var r;return (r=o.pending_processes)!=null?r:[]});}}),{receivedApplicationFormPendingProcess:Jr}=Kr.actions,Xr=Kr,Yr=(e,t)=>{if(!t)return [];let o=e.findIndex(r=>r.id===t.id);return o>=0?e[o]=t:e.push(t),e},zr=(e,t)=>{let{pending_processes:o=[]}=t;return o.length?e:[]};function Zr(e){return c(n({},cloneDeep_1(e)),{updated_at:new Date().toISOString()})}var A=createAsyncThunk("answers/Update",(i,s)=>p(void 0,[i,s],function*(e,{getState:t,rejectWithValue:o,dispatch:r}){try{let a=t(),d=Ze$2(e.answer,Xe$2(e.answer));return a.queues.answers.outbound[e.answer.id]?d.length?Zr(e.answer):(yield v$1.updateAnswer(e.answer,e.config)).parsedBody:(r(Pe(e.answer)),Zr(e.answer))}catch(a){let d=new L("Error updating answer",a);throw nr$1(d),o(d)}}));var go="viewState/AddressValidation",qe=createAsyncThunk(`${go}/validateAddress`,(r,i)=>p(void 0,[r,i],function*(e,{getState:t,rejectWithValue:o}){var u;let s=`https://addressvalidation.googleapis.com/v1:validateAddress?key=${e.googleApiKey}`,a={address:{addressLines:[e.street_1,e.street_2,e.city,e.state,e.zipcode],regionCode:"US"},previousResponseId:""},d=t();a.previousResponseId=(u=Rr(d,e.addressValidationId).responseId)!=null?u:"";try{let m=yield fetch(s,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(a)});if(!m.ok)throw new Error("There was an error with this request");let I=yield m.json();return I.addressValidationId=e.addressValidationId,I.originalAddressComponents={street_1:e.street_1,street_2:e.street_2,city:e.city,state:e.state,zipcode:e.zipcode},I}catch(m){let I=new L("Error validating address",m);throw o(I)}})),Zh=createAsyncThunk(`${go}/saveValidatedAddressAnswers`,(r,i)=>p(void 0,[r,i],function*(e,{dispatch:t,rejectWithValue:o}){try{let s=Gd(e.addressComponents),a=yield Promise.allSettled(Object.entries(s).map(([m,I])=>{let F=e.answerMap[m].question.reference_type==="state"?c(n({},e.answerMap[m]),{choice_id:Dd(I,e.answerMap[m])}):c(n({},e.answerMap[m]),{value:I});return t(A({answer:F,config:e.config}))})),d=a.filter(ri);return a.filter(oi).map(m=>{throw new Error(m.reason)}),d.map(m=>m.value.payload)}catch(s){let a=new L("Error saving address",s);throw nr$1(a),o(a)}})),Ot=createAsyncThunk(`${go}/saveAddressValidationMissingAnswers`,(r,i)=>p(void 0,[r,i],function*(e,{rejectWithValue:t,dispatch:o}){try{let s=yield Promise.allSettled(e.answersToSave.map(u=>o(A({answer:u,config:e.config})))),a=s.filter(ri);return s.filter(oi).map(u=>{throw new Error(u.reason)}),{addressValidationId:e.addressValidationId,answers:a.map(u=>u.value.payload)}}catch(s){let a=new L("Error saving address",s);throw nr$1(a),t(a)}})),oi=e=>e.status==="rejected",ri=e=>e.status==="fulfilled",Gd=e=>{let t=e.filter(o=>(o.inferred||o.replaced||o.spellCorrected)&&o.componentType!==W$2.POSTAL_CODE_SUFFIX);return Object.fromEntries(t.map(o=>{switch(o.componentType){case W$2.ROUTE:case W$2.STREET_NUMBER:case W$2.STREET_ADDRESS:return [B.STREET_1,`${ei(W$2.STREET_NUMBER,e)} ${ei(W$2.ROUTE,e)}`];default:return [Ii$1(o.componentType),o.componentName.text]}}))},ei=(e,t)=>{var o,r;return (r=(o=t.find(i=>i.componentType===e))==null?void 0:o.componentName.text)!=null?r:""},Dd=(e,t)=>{var o,r;return (r=(o=t.question.choices.find(i=>i.alias===e))==null?void 0:o.id)!=null?r:""};var fe=createAsyncThunk("quoteableCarriersProduct/Load",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield F.getApplicationFormCarriersProducts(e.appFormId,e.config)).parsedBody}catch(i){let s=new L("Error getting carrier products",i);throw nr$1(s),t(s),s}}));var Ve=createAsyncThunk("choices/Search",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield b$1.searchChoices(e.questionId,{filter:e.filter},e.config)).parsedBody}catch(i){let s=new L("Error searching choices",i);throw nr$1(s),t(s),s}})),q=createAsyncThunk("choicesWithNudges/Search",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield b$1.searchChoicesWithNudges(e.questionId,{filter:e.filter,refilter:e.refilter},e.config)).parsedBody}catch(i){let s=new L("Error searching choices",i);throw nr$1(s),t(s),s}}));var bt=createAsyncThunk("features/Search",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield $.getFeatures(e.config)).parsedBody}catch(i){let s=new L("Error getting features",i);throw nr$1(s),t(s),s}}));var pi="questionPools",Et=createAsyncThunk(`${pi}/Add`,(r,i)=>p(void 0,[r,i],function*(e,{getState:t,rejectWithValue:o}){var s;try{let a=t();if(e.parent_question_pool_id){let u=a.application.questionSets.list.find(m=>m.question_set.question_pools.some(I=>I.id===e.parent_question_pool_id));u&&(e=c(n({},e),{parent_answer_pool_id:(s=u.answers.find(m=>m.answer_pool_id===e.selected_answer_pool_id))==null?void 0:s.answer_pool_id}));}return (yield H.addQuestionPool(e)).parsedBody}catch(a){let d=new L("Error adding question pool",a);return nr$1(d),o(d)}})),Tt=createAsyncThunk(`${pi}/Remove`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{let i=yield H.removeQuestionPool(e);return e.callback&&e.callback(),i.parsedBody}catch(i){let s=new L("Error adding question pool",i);return nr$1(s),t(s)}}));var Co="questionSets",Me=createAsyncThunk(`${Co}/LoadOne`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield R.getQuestionSet(e.appForm,{id:e.id},e.config)).parsedBody}catch(i){let s=new L("Error loading single question set",i);throw nr$1(s),t(s),s}})),G_=createAsyncThunk(`${Co}/Create`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield R.createQuestionSet(e.appFormQuestionSet,e.config)).parsedBody}catch(i){let s=new L("Error loading single question set",i);throw nr$1(s),t(s),s}})),Be=createAsyncThunk(`${Co}/Save`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{let i=e.parentQuestionSet?c(n({},e.parentQuestionSet),{is_completed:!0}):c(n({},e.appFormQuestionSet),{is_completed:!0});return (yield R.updateQuestionSet(i,e.config)).parsedBody}catch(i){let s=new L("Error saving question set",i);return nr$1(s),t(s)}}));var Ne=createAsyncThunk("bindQuote/Bind",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){var i;try{let s=yield w$1.bindQuote(e.quoteId,e.appFormId,e.config);return e.afterResponse&&e.afterResponse(((i=s.parsedBody)==null?void 0:i.retrieve_url)||""),s.parsedBody}catch(s){let a=new L("Error binding quote request",s);throw nr$1(a),t(a),a}})),Lt=createAsyncThunk("bindQuote/action",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{let{action:i,quote:s,config:a}=e;return yield w$1.bindQuoteAction(i,s,a)}catch(i){let s=new L("Error binding quote request",i);throw t(s),s}}));var Se="vehicleOptions",b=createAsyncThunk(`${Se}/LoadFull`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{let i=q$1.getYears(e.config),s=q$1.getMakes(e.year,e.config,{category:e.category}),a=q$1.getModels(e.year,e.makeId,e.config,e.category),d=q$1.getConfigurations(e.year,e.makeId,e.modelId,e.config,e.category),{parsedBody:u}=yield i,{parsedBody:m}=yield s,{parsedBody:I}=yield a,{parsedBody:F}=yield d;return {years:u,makes:m,models:I,configurations:F}}catch(i){let s=new L("Error loading full vehicle options",i);throw nr$1(s),t(s),s}})),W=createAsyncThunk(`${Se}/LazyLoad`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){var i,s,a,d,u,m;try{let I=q$1.getYears(e.config),F=q$1.getMakes(e.year,e.config,{category:e.category}),{parsedBody:ct}=yield I,He=e.isMakeFreeFormValue?[]:(yield F).parsedBody,z=e.isMakeFreeFormValue?e.make:(s=(i=He.find(N=>N.name.toUpperCase()===e.make.toUpperCase()))==null?void 0:i.id)==null?void 0:s.toString(),xe=[];z&&!e.isMakeFreeFormValue&&!e.isModelFreeFormValue&&(xe=(yield q$1.getModels(e.year,z,e.config,e.category)).parsedBody);let we=e.isModelFreeFormValue?e.model:(d=(a=xe.find(N=>N.name.toUpperCase()===e.model.toUpperCase()))==null?void 0:a.id)==null?void 0:d.toString(),ve=[];z&&we&&!e.isModelFreeFormValue&&(ve=(yield q$1.getConfigurations(e.year,z,we,e.config,e.category)).parsedBody);let lt=(m=(u=ve.find(N=>{var Ye;return N.name.toUpperCase()===((Ye=e.configuration)==null?void 0:Ye.toUpperCase())}))==null?void 0:u.id)==null?void 0:m.toString();return {years:ct,makes:He,models:xe,configurations:ve,yearId:e.year,makeId:z,modelId:we,configurationId:lt,questionGroupId:e.questionGroupId}}catch(I){let F=new L("Error loading full vehicle options",I);throw nr$1(F),t(F),F}})),f=createAsyncThunk(`${Se}/LoadYears`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield q$1.getYears(e.config)).parsedBody}catch(i){let s=new L("Error loading vehicle years",i);throw nr$1(s),t(s),s}})),g=createAsyncThunk(`${Se}/LoadMakes`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield q$1.getMakes(e.year,e.config,{category:e.category})).parsedBody}catch(i){let s=new L("Error loading vehicle makes",i);throw nr$1(s),t(s),s}})),x=createAsyncThunk(`${Se}/LoadModels`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield q$1.getModels(e.year,e.makeId,e.config,e.category)).parsedBody}catch(i){let s=new L("Error loading vehicle makes",i);throw nr$1(s),t(s),s}})),Ue=createAsyncThunk(`${Se}/LoadConfigurations`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return (yield q$1.getConfigurations(e.year,e.makeId,e.modelId,e.config,e.category)).parsedBody}catch(i){let s=new L("Error loading vehicle configurations",i);throw nr$1(s),t(s),s}})),S=createAsyncThunk(`${Se}/LoadVin`,(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{return yield q$1.getVinDetails(e.vin,e.config)}catch(i){let s=new L("Error loading VIN",i);return nr$1(s),t(s)}})),Ft=createAsyncThunk("selectVehicle/Save",(o,r)=>p(void 0,[o,r],function*(e,{rejectWithValue:t}){try{let i=yield q$1.selectVehicle(e);return i&&e.callback&&e.callback(),i.parsedBody}catch(i){let s=new L("Error saving vehicle selection",i);throw nr$1(s),t(s),s}}));var Ai=(e,t)=>(e.parentQuestionSets=cc(t,e.parentQuestionSets),e.list=nc(e.list,t),e),Ii=e=>e.filter(t=>xo(t)),xo=e=>{var t;return (t=e==null?void 0:e.question_set.question_groups)==null?void 0:t.some(o=>hn$1(o))},hi=(e,t)=>{let o=e;return t.forEach(r=>{let i=_i(r),s=vi(e,r.order);o.splice(s,1,...i);}),o},wo=e=>!!e.parentQuestionSetId;var vo=(e,t,o)=>{let r=o.list.filter(i=>i.parentQuestionSetId===e.id).filter(i=>!i.is_blank);return r.length&&r.findIndex(s=>s.question_set_id===t.question_set_id)===r.length-1?void 0:t};function nc(e,t){let o=e.filter(s=>s.parentQuestionSetId!==t.id),r=_i(t),i=vi(o,t.order);return o.splice(i,0,...r),o}function _i(e){let t=fn$1(e,dn$1(e));return Array.from(t.values()).filter(o=>hn$1(o)).flatMap(o=>Array.from(o.nestedGroupsWithAnswers.values()).filter(i=>yn$1(i)).sort((i,s)=>wn$1(i,s)).map(i=>ac(i,e)))}function ac(e,t){let o=t.question_set.question_groups.find(a=>a.id===e.groupId),r=Ci(e),i=wi(t.question_set.question_groups,o),s={answers:r,application_form_id:t.application_form_id,completed_at:null,created_at:t.created_at,id:e.groupId,is_active:t.is_active,is_blank:dc(r,t.question_set.question_pools),next_active_question_set_id:t.next_active_question_set_id,order:t.order,question_set:{code:e.parentQuestionAnswer.question.code,created_at:t.question_set.created_at,id:e.parentQuestionAnswer.id,name:e.label,owner_id:t.question_set.owner_id,question_groups:xi(t.question_set.question_groups,o),question_ids:i,question_pools:t.question_set.question_pools.filter(a=>i.includes(a.parent_question_id)),subdomain:t.question_set.subdomain,tenant_id:t.question_set.tenant_id,title:e.label,updated_at:t.updated_at},question_set_id:e.parentQuestionAnswer.id,updated_at:t.updated_at,parentQuestionSetId:t.id};return s.is_completed=et$2(s),s}function Ci(e){let t=e.answers;return e.nestedGroupsWithAnswers.forEach(o=>{t=[...t,...Ci(o)];}),t.sort(ee$3)}function xi(e,t){if(!t)return [];let o=[];return e.forEach(r=>{t.question_ids.includes(r.parent_question_id)&&(o.push(r),o=[...o,...xi(e,r)]);}),o}function wi(e,t){if(!t)return [];let o=t==null?void 0:t.question_ids;return e.forEach(r=>{t.question_ids.includes(r.parent_question_id)&&(o=[...o,...wi(e,r)]);}),o}function dc(e,t){return e.length>0?e.every(r=>r.question.field_type===C$2.Anchor)?e.find(r=>t.find(i=>i.parent_question_id===r.question.id))===void 0:!1:!0}function vi(e,t){let o=e.findIndex(r=>r.order>=t);return o===-1&&(o=e.length),o}function cc(e,t){return [...t.filter(r=>r.question_set_id!==e.question_set_id),e]}var qt=(e,t,o)=>{if(o){let r=e.list.findIndex(i=>i.question_set_id===o.question_set_id);return r===-1&&(r=uc(o.id,e.list)),t==="backward"?lc(e.list,r):ki(e.list,r)}return ge(e.list)},Pi=(e,t,o)=>t?qt(e,t,o||void 0):ge(e.list),Qi=(e,t,o,r)=>{let i=t.next_active_question_set_id;return i&&!r?Vt(e,i):o?qt(e,o,r||t):ge(e.list)},ge=e=>{let t=e.filter(r=>Zn(r));if(t.length===0)return "";let o=t.find(r=>!r.is_completed);if(o)return o.question_set_id;{let r=e.filter(Zn);return r[r.length-1].question_set_id}};function Vt(e,t){var r;let o=e.list.findIndex(i=>i.id===t);if(o!==-1)return e.list[o].is_blank?ki(e.list,o):e.list[o].question_set_id;if(e.parentQuestionSets.find(s=>s.id===t))return (r=e.list.filter(Zn).find(a=>a.parentQuestionSetId===t))==null?void 0:r.question_set_id}function lc(e,t){if(t<=0)return e[0].question_set_id;let o;for(let r=t-1;r>=0;r--)if(Zn(e[r])){o=e[r].question_set_id;break}return o!=null?o:e[t].question_set_id}function ki(e,t){if(t>=e.length-1)return e[e.length-1].question_set_id;let o;for(let r=t+1;r<e.length;r++)if(Zn(e[r])){o=e[r].question_set_id;break}return o!=null?o:e[t].question_set_id}function uc(e,t){let o=t.findIndex(r=>r.is_completed===!1&&r.parentQuestionSetId===e);if(o===-1){for(let r=t.length-1;r>=0;r--)if(t[r].parentQuestionSetId===e){o=r;break}}return o}var Oi=n({},Sa),Bi=createSlice({name:"questionSets",initialState:Oi,reducers:{switchActiveQuestionSet:(e,t)=>{let o=e.list.find(r=>r.question_set_id===e.active);o&&wo(o)&&(o.is_completed=et$2(o)),e.active=qt(e,t.payload,o);},updateActiveQuestionSet:(e,{payload:t})=>{Fi(e),e.active=t;},goToCarrierQuestionSet:(e,{payload:t})=>{let o=e.list.find(r=>r.question_set.tenant_id===t);o&&(Fi(e),e.active=o.question_set_id);},markActiveQuestionSetCompleted:e=>{let t=e.list.findIndex(o=>o.question_set_id===e.active);t!==-1&&(e.list[t].is_completed=R$2(e.list[t].answers));},receiveQuestionSet:(e,{payload:t})=>Ei(e,t),removeQuestionSet:(e,{payload:t})=>Li(e,t),receiveUpdatedAnswer:(e,{payload:t})=>Ti(e,t),updateActiveAnswerId:(e,{payload:t})=>{let o=c(n({},e),{activeAnswerId:t,pendingActiveAnswerUpdate:void 0});return e.pendingActiveAnswerUpdate?ie(o,e.pendingActiveAnswerUpdate):o},removeActiveAnswerId:e=>bi(e),updateLockQuestionSet:(e,{payload:t})=>c(n({},e),{lockQuestionSet:t})},extraReducers:e=>{e.addCase(Ot.fulfilled,t=>bi(t)).addCase(Be.fulfilled,(t,{payload:o,meta:r})=>{if(wc(t,o))return t;Rc(o)?Sc(t,r):gc(t,o,r);}).addCase(A.pending,(t,{meta:o})=>ie(t,c(n({},o.arg.answer),{version:o.arg.answer.version+1}),!1)).addCase(A.rejected,(t,{meta:o})=>qi(t,o.arg.answer)?t:ie(t,o.arg.answer,!1)).addCase(A.fulfilled,(t,{payload:o})=>qi(t,o)?t:ie(t,o)).addCase(gt,(t,{payload:o})=>{let r=c(n({},ie(t,o,!1)),{pendingActiveAnswerUpdate:void 0}),i=ko(t,o);if(i!==-1){let s=r.list[i];s.is_completed=!1;}return r}).addCase(Me.fulfilled,(t,{payload:o})=>Qo(t,o,!1)).addCase(Q,(t,{payload:o})=>{let r=n({},t);return o.events.forEach(i=>{switch(i.event){case xe$1.AddQuestionSet:r=Ei(r,i.data);break;case xe$1.RemoveQuestionSet:r=Li(r,i.data);break;case xe$1.Answer:r=Ti(r,i.data);break}}),Pc(o.events)&&(r.active=vc(r)),r}),e.addMatcher(isAnyOf(...h),(t,{payload:o})=>{let r=Ii(o.application_forms_question_sets);t.list=Ac(o.application_forms_question_sets,r),t.active=ge(t.list),t.activeAnswerId="",t.parentQuestionSets=r;}).addMatcher(isAnyOf(...l),t=>n({},Oi));}}),{switchActiveQuestionSet:ox,updateActiveQuestionSet:rx,receiveQuestionSet:Ni,removeQuestionSet:Ui,receiveUpdatedAnswer:Gi,updateActiveAnswerId:ix,removeActiveAnswerId:sx,goToCarrierQuestionSet:nx,markActiveQuestionSetCompleted:ax,updateLockQuestionSet:dx}=Bi.actions,Di=Bi,bi=e=>{let t=c(n({},e),{activeAnswerId:"",pendingActiveAnswerUpdate:void 0});return e.pendingActiveAnswerUpdate?ie(t,e.pendingActiveAnswerUpdate):t},Sc=(e,t)=>{e.completedQuestionSetAnswerHasChanged=!(e.completedQuestionSetAnswerHasChanged&&ji(e.list));let o=t.arg.parentQuestionSet?vo(t.arg.parentQuestionSet,t.arg.appFormQuestionSet,e):void 0;e.active=Pi(e,t.arg.navigationDirection,o);},gc=(e,t,o)=>{let r=Qo(e,t,!1);e.list=r.list,e.parentQuestionSets=r.parentQuestionSets;let i=o.arg.parentQuestionSet?vo(o.arg.parentQuestionSet,o.arg.appFormQuestionSet,e):void 0,s=Qi(r,t,o.arg.navigationDirection,i);s?e.active=s:t.next_active_question_set_id?e.idOfNextActiveQuestionSetNotInState=t.next_active_question_set_id:e.active=ge(r.list);},Ei=(e,t)=>{let o=Qo(e,t);return e.list=o.list,e.completedQuestionSetAnswerHasChanged=o.completedQuestionSetAnswerHasChanged,e.parentQuestionSets=o.parentQuestionSets,e.idOfNextActiveQuestionSetNotInState===t.id&&(e.active=Vt(e,e.idOfNextActiveQuestionSetNotInState),e.idOfNextActiveQuestionSetNotInState=void 0),e},Ti=(e,t)=>ie(e,t),Li=(e,t)=>(e.list=e.list.filter(o=>o.id!==t.id&&o.parentQuestionSetId!==t.id),e.parentQuestionSets=e.parentQuestionSets.filter(o=>o.id!==t.id),e);function ie(e,t,o=!0){let r=ko(e,t);if(r!==-1){let i=lodash.exports.cloneDeep(e),{answer:s,index:a}=Qc(i,t),d=i.list[r];if(s)Oc(s,t)&&(yc(t)?Vi(e,i,s,t,o):d.answers.splice(a,1));else if(t.active&&t.display_type!=="private"){let u=bc(d,t);d.answers.splice(u,0,t);}return d.parentQuestionSetId&&(d.is_blank=d.answers.length===0),i}else if(!!Kn$1(t,e)){let s=lodash.exports.cloneDeep(e),a=Kn$1(t,s),d=a==null?void 0:a.answers.find(u=>u.id===t.id);return d&&Vi(e,s,d,t,o),s}return e}function Qo(e,t,o=!0){let r=lodash.exports.cloneDeep(e),i=r.completedQuestionSetAnswerHasChanged;if(xo(t))r=Ai(r,t);else {let s=r.list.findIndex(a=>a.question_set_id===t.question_set_id);if(s>-1){let a=r.list[s],d=!e.completedQuestionSetAnswerHasChanged&&_c(a.is_completed,t.is_completed);if(a.completed_at=t.completed_at,a.is_active=t.is_active,a.is_completed=t.is_completed,a.order=t.order,a.updated_at=t.updated_at,a.is_blank=t.is_blank,o)for(let u of t.answers)r=ie(r,u);d&&(i=!0);}else r.list=Cc(r.list,t);}return r.completedQuestionSetAnswerHasChanged&&ji(r.list)&&(i=!1),r.completedQuestionSetAnswerHasChanged=i,r}function Ac(e,t){return hi(e,t)}function Ic(e,t){return e.findIndex(o=>o.question_set_id===t)}function hc(e,t,o){let r=t.list.findIndex(i=>i.answers.find(s=>s.question.id===o));if(r===-1){let i=e.question_set.question_groups.find(s=>s.question_ids.includes(o));if(i){let s=t.list.findIndex(a=>a.question_set.question_groups.find(d=>d.id===i.id));return s===-1?t.list.findIndex(a=>a.id===i.id):s}}return r}var _c=(e,t)=>!!e&&!t;function ko(e,t){let o=e.parentQuestionSets.find(r=>r.question_set_id===t.question.question_set_id);return o?hc(o,e,t.question.id):Ic(e.list,t.question.question_set_id)}function Fi(e){let t=e.list.find(o=>o.question_set_id===e.active);t&&wo(t)&&(t.is_completed=et$2(t));}function Cc(e,t){let o=xc(e,t.order);return e.splice(o,0,t),e}function xc(e,t){let o=e.findIndex(r=>r.order>=t);return o===-1&&(o=e.length),o}function ji(e){return e.length?e.slice(0,-1).every(t=>t.is_completed):!1}function wc(e,t){var o;return !!t.application_form_id&&((o=e.list[0])==null?void 0:o.application_form_id)!==t.application_form_id}function vc(e){let t=e.list.find(o=>o.question_set_id===e.active);return e.active&&!t&&!e.idOfNextActiveQuestionSetNotInState?ge(e.list):e.active}function Pc(e){return e.some(t=>t.event===xe$1.RemoveQuestionSet&&!t.data.next_active_question_set_id)}function Qc(e,t){let o=ko(e,t);return kc(t,o>=0?e.list[o]:void 0)}function kc(e,t){let o=(s,a)=>({answer:a&&s>=0?a.answers[s]:void 0,index:s}),r=(s,a)=>{let d=u=>m=>m.id===u;return a.findIndex(d(s))},i=-1;return t&&(i=r(e.id,t.answers)),o(i,t)}function yc(e){return e.active&&e.display_type!=="private"}function qi(e,t){var o;return ((o=e.list[0])==null?void 0:o.application_form_id)!==t.application_form_id}function Rc(e){return !e.id}function Oc(e,t){let o=new Date(e.updated_at);return new Date(t.updated_at)>=o&&t.version>=e.version||t.created_at===e.created_at}function Vi(e,t,o,r,i){e.activeAnswerId!==r.id?Object.assign(o,r):(Object.assign(o,r,{value:o.value,choice_id:o.choice_id,choice_ids:o.choice_ids,updated_at:o.updated_at}),i&&(t.pendingActiveAnswerUpdate=r));}function bc(e,t){let o=e.answers.length;for(let r=0;r<e.answers.length;r++)if(e.answers[r].question.order>=t.question.order){o=r;break}return o}var Lc=[],$i=createSlice({name:"quotes",initialState:Lc,reducers:{receiveQuoteRequest:(e,{payload:t})=>yo(e,t)},extraReducers:e=>{e.addCase(Q,(t,{payload:o})=>{let r=[...t];return o.events.forEach(i=>{switch(i.event){case xe$1.QuoteRequest:r=yo(r,i.data);break}}),r}).addMatcher(isAnyOf(...h),(t,{payload:o})=>{if(o!=null&&o.quote_requests){let r=[];return r=o.quote_requests.reduce((i,s)=>yo(i,s),r),r}return t}).addMatcher(isAnyOf(...l),t=>[]);}}),{receiveQuoteRequest:Hi}=$i.actions,Yi=$i,yo=(e,t)=>{var s;let o=[...e],r=e.filter(a=>a.id===t.id||a.parentQuoteRequestId===t.id);if(r.length){let a=new Date(r[0].updated_at);new Date(t.updated_at)>=a&&(o=e.filter(u=>u.id!==t.id&&u.parentQuoteRequestId!==t.id));}if(t.active){let i=t,d=pt(i,["quotes"]);o.push(...((s=t.quotes)!=null?s:[]).map(u=>c(n(n({},d),u),{id:`${t.id}${u.supplier_code?`-${u.supplier_code}`:""}`,parentQuoteRequestId:t.id})));}return o};var Vc=(e,t,o="")=>{let{data:r,event:i}=e;switch(i){case xe$1.Appetite:t.dispatch(Nr(r));break;case xe$1.AddQuestionSet:t.dispatch(Ni(r));break;case xe$1.RemoveQuestionSet:t.dispatch(Ui(r));break;case xe$1.ApplicationForm:t.dispatch(ee(r));break;case xe$1.Message:t.dispatch(Le(r));break;case xe$1.QuoteRequest:t.dispatch(Hi(r));break;case xe$1.Answer:t.dispatch(Gi(r));break;case xe$1.CarrierProducts:t.dispatch(Rt(r.length>0?r.filter(s=>s.application_form_id===o):r));break;case xe$1.ApplicationFormPercentCompleted:t.dispatch(yt(r));break;case xe$1.ApplicationFormProcess:t.dispatch(Jr(r));break;case xe$1.RealTimeEligibility:t.dispatch(Ur(r));break;case xe$1.Notification:t.dispatch(Wr(r));break;case xe$1.Batch:t.dispatch(Q(r));break}},Mc=(e,t)=>{if(!(e!=null&&e.data))return !0;switch(e.event){case xe$1.ApplicationForm:return e.data.id!==t;case xe$1.ApplicationFormPercentCompleted:return e.data.application_form_id!==t;case xe$1.CarrierProducts:return e.data.length>0?e.data.filter(o=>o.application_form_id===t).length===0:!1;case xe$1.Notification:return !1;case xe$1.Batch:return !1;case xe$1.Appetite:default:return e.data.application_form_id!==t}},Bc=(e,t,o)=>{Mc(t,o)||Vc(t,e,o);},Nc=e=>t=>o=>{Bc(e,o,t);},zi,Ki=(e,t,o)=>{e===b$2.Disconnected&&console.error("Websocket has disconnected. Attempting to reconnect."),o.dispatch(Ze({status:e,appId:t}));};var Uc=(e,t)=>()=>Ki(b$2.Connected,e,t),Gc=(e,t)=>()=>Ki(b$2.Disconnected,e,t),Dc=(e,t,o=zi)=>{o!=null&&o.disconnect();let r=Nc(e),{config:{wsBaseUri:i,options:{enableWebSockets:s}}}=e.getState(),{payload:{cable_token:a,id:d}}=t;s&&i&&(zi=o=new Xo({wsBaseUri:i,token:a,id:d}),o.start(),o.subscribe("ApplicationFormChannel",{id:d},{received:r(d),connected:Uc(d,e),disconnected:Gc(d,e)}));},jc=e=>t=>o=>(isAction(o)&&isAnyOf(...h)(o)&&(e.dispatch(At({appId:o.payload.id})),e.dispatch(Ze({status:b$2.Connecting,appId:o.payload.id})),Dc(e,o)),t(o)),Ji=jc;var $c=e=>t=>o=>{if(isAction(o)){let{config:{debug:r}}=e.getState();if(r){console.group(o.type),console.info("dispatching",o);let i=t(o);return console.log("next state",e.getState()),console.groupEnd(),i}}return t(o)},Xi=$c;var Zi=n({},Ti$1),es=createSlice({name:"auth",initialState:Zi,reducers:{setAuth:(e,{payload:t})=>c(n(n({},e),t),{refreshCount:e.refreshCount+1}),setUser:(e,{payload:t})=>n(n({},e),Yt(t)),setImpersonatedOnAuth:(e,{payload:t})=>{e.options.impersonated=t.sudo;},loggedOut:e=>n({},Zi),setTheme:(e,{payload:t})=>{e.terminalTheme=t;}}}),{setAuth:ts,setUser:os,setImpersonatedOnAuth:zx,loggedOut:Ae,setTheme:Kx}=es.actions,rs=es;var is=n({},sa$1),ss=createSlice({name:"config",initialState:is,reducers:{setConfig:(e,{payload:t})=>c(n(n({},e),t),{options:n(n({},e.options),t.options)}),setWebSocketConfig:(e,{payload:t})=>{e.options.enableWebSockets=t.enableWebsocket;}},extraReducers:e=>{e.addCase(K,t=>n({},is)).addMatcher(isAnyOf(...h),(t,{payload:o})=>{t.cableToken=o.cable_token;});}}),{setConfig:ns,setWebSocketConfig:sw}=ss.actions,as=ss;var ds=n({},he$1),cs=createSlice({name:"status/Local",initialState:ds,reducers:{setLocalStatusState:(e,{payload:t})=>{e.state=t;},setLocalStatusHealth:(e,{payload:t})=>{e.health=t;}},extraReducers:e=>{e.addCase(K,t=>n({},ds)).addCase(ts,t=>{t.auth=u$1.Configured;}).addCase(ns,t=>{t.config=u$1.Configured;}).addCase(os,t=>{t.user=u$1.Configured;}).addCase(Zo,t=>{t.auth=u$1.Error,t.user=u$1.Error;}).addCase(Ae,t=>{t.auth=u$1.NotLoaded,t.user=u$1.NotLoaded;}).addCase(Ze,(t,{payload:o})=>{t.socket=o.appId===t.socketId?o.status:t.socket;}).addCase(At,(t,{payload:o})=>{t.socketId=o.appId;});}}),{setLocalStatusState:nt,setLocalStatusHealth:at}=cs.actions,ls=cs;function us(e,t,o){t(A({answer:o,config:mr(e)}));}function rl(e,t){return A.fulfilled.match(t)?e.application.form.id!==t.payload.application_form_id:!1}function ps(e,t){let o=e.queues.answers.queue.length,r=Object.keys(e.queues.answers.outbound).length;o&&!r&&us(e,t,e.queues.answers.queue[0]);}function il(e,t,o){let r=e.queues.answers.queue.length,i=Object.keys(e.queues.answers.outbound).length;!r&&!i?us(e,t,o):t(Pe(o));}function sl(e,t,o){e.queues.answers.queue[0]&&e.queues.answers.queue[0].id!==o.payload.id&&ps(e,t);}var nl=e=>t=>o=>{if(isAction(o)){let r=e.getState();if(rl(r,o))return t(o);let i=e.dispatch;if(isAnyOf(A.pending,nt,at,Le,Ae)(o))return t(o);A.fulfilled.match(o)?sl(r,i,o):gt.match(o)?il(r,i,o.payload):ps(r,i);}return t(o)},ms=nl;var fs=n({},ma),Ss=createSlice({name:"error",initialState:fs,reducers:{updateErrors:(e,{payload:t})=>c(n({},e),{[t.answer.id]:t.errors}),removeError:(e,{payload:t})=>c(n({},e),{[t]:[]})},extraReducers:e=>{e.addCase(A.pending,(t,{meta:o})=>{let{answer:r}=o.arg,i=Ze$2(r);t[r.id]=i;}).addCase(A.rejected,(t,{meta:o,payload:r})=>{var d,u,m;let i=(u=(d=r==null?void 0:r.response)==null?void 0:d.parsedBody)!=null?u:[],s=o.arg.answer.id,a=(m=t[s])!=null?m:[];return c(n({},t),{[s]:[...a,...i]})}),e.addMatcher(isAnyOf(...l),t=>n({},fs));}}),{updateErrors:qw,removeError:gs}=Ss.actions,As=Ss;var fl=e=>t=>t.question.reference_type===v$2.Accumulator&&Sl(t.id,e)&&He$1(t),Sl=(e,t)=>t[e]!==void 0,gl=e=>t=>o=>{if(isAction(o)&&o.type===A.fulfilled.type){let{application:r}=e.getState();if(!r)return;let{errors:i,questionSets:{list:s}}=r;s.flatMap(a=>a.answers).filter(a=>fl(i)(a)).forEach(a=>{e.dispatch(gs(a.id));});}return t(o)},Is=gl;var hs=e=>[e.status.remote.application.form,e.status.remote.questionSets.state,e.status.remote.questionPools.state,e.status.remote.answers.state,...Object.values(e.status.remote.bindQuotes),...Object.values(e.status.remote.choices),...Object.values(e.status.remote.refilters),...Object.values(e.status.remote.vehicles.configurations),...Object.values(e.status.remote.vehicles.makes),...Object.values(e.status.remote.vehicles.models),...Object.values(e.status.remote.vehicles.selection),...Object.values(e.status.remote.vehicles.vins),...Object.values(e.status.remote.vehicles.years)],Il=e=>[...hs(e),e.status.remote.quotes.state],hl=e=>e.status.remote.application.form,_l=e=>!!(e.auth.user&&e.config.clientId),Cl=e=>hs(e).reduce((o,r)=>{switch(r){case R$1.Error:o=u$1.Configured;break;case R$1.NotLoaded:o=u$1.Configured;break;case R$1.Loading:o!==u$1.Configured&&(o=u$1.Loading);break;case R$1.Loaded:o!==u$1.Configured&&o!==u$1.Loading&&(o=u$1.Loaded);break}return o},u$1.Loaded),xl=e=>e===R$1.Error?h$2.Error:h$2.Healthy,wl=e=>Il(e).reduce((o,r)=>o===h$2.Error?o:xl(r),h$2.Healthy),vl=e=>{let t=u$1.NotLoaded;if(_l(e)){t=u$1.Configured;let o=hl(e);o===R$1.Loaded?t=Cl(e):o===R$1.Loading&&(t=u$1.Loading);}return t},Pl=e=>t=>o=>{if(isAction(o)){let r=e.getState();switch(o.type){case nt.type:case at.type:return t(o)}let i=vl(r),s=wl(r);i!==r.status.local.state&&e.dispatch(nt(i)),s!==r.status.local.health&&e.dispatch(at(s));}return t(o)},_s=Pl;var bl=new L().name;function El(e){return e.payload&&e.payload.error&&bl===e.payload.error.name}var Tl=e=>t=>o=>{if(isAction(o)){if(o.type===Ae.type)return $t(),t(o);let i=e.getState().config.debug;if(El(o)){let a=o.payload.error.response;if((a==null?void 0:a.status)===401){i&&console.error("User is trying to make an unauthenticated request, logging out."),e.dispatch(Ae());let d={id:"logoutExpired",tenant_id:"",owner_id:"",target:"Your login has expired. Please log in again to continue.",application_form_id:"",active:!0,created_at:new Date,updated_at:new Date,code:"",level:de$2.warning,location:null,metadata:{},component:ce$1.Application,priority:!1};e.dispatch(Le(d));}}}return t(o)},Cs=Tl;var Vl=e=>t=>o=>{if(isAction(o)&&isAnyOf(...h)(o)){let r=x$2(`bp-sdk-validation:${o.payload.id}`);r&&e.dispatch(ws(JSON.parse(r)));}return t(o)},xs=Vl;var vs=[xs,ms,Cs,Xi,_s,Is,Ji];var Ro=n({},La$1),Qs=createSlice({name:"viewState/AddressValidation/validateAddress",initialState:Ro,reducers:{initializeAddressValidation:(e,t)=>e.validations[t.payload]?e:c(n({},e),{validations:c(n({},e.validations),{[t.payload]:n({},V$1)})}),hydrateAddressValidation:(e,t)=>c(n({},e),{validations:t.payload}),setAddressValidationTriggerOverridden:(e,t)=>c(n({},e),{shouldOverrideValidationTrigger:t.payload}),stageAddressValidationAnswer:(e,t)=>{let{answerToStage:o,addressValidationId:r}=t.payload,i=e.validations[r].stagedAnswers.filter(s=>s.answer.id!==o.answer.id);return c(n({},e),{validations:c(n({},e.validations),{[r]:c(n({},e.validations[r]),{stagedAnswers:[...i,o]})})})},setAddressValidationStatus:(e,t)=>c(n({},e),{validations:c(n({},e.validations),{[t.payload.addressValidationId]:c(n({},e.validations[t.payload.addressValidationId]),{validationStatus:t.payload.validationStatus})})}),addAddressValidationAttempt:(e,t)=>c(n({},e),{validations:c(n({},e.validations),{[t.payload.addressValidationId]:c(n({},e.validations[t.payload.addressValidationId]),{attempt:e.validations[t.payload.addressValidationId].attempt+1})})}),resetAddressValidation:(e,t)=>c(n({},e),{validations:c(n({},e.validations),{[t.payload]:c(n({},e.validations[t.payload]),{verdict:null,address:null,stagedAnswers:[]})})}),resetAddressValidationAttempt:(e,t)=>c(n({},e),{validations:c(n({},e.validations),{[t.payload]:c(n({},e.validations[t.payload]),{attempt:e.validations[t.payload].attempt-1})})})},extraReducers:e=>{e.addCase(qe.fulfilled,(t,o)=>{let{addressValidationId:r,responseId:i,originalAddressComponents:s,result:a}=o.payload,d=Gl(a);t.validations[r].responseId=t.validations[r].responseId?t.validations[r].responseId:i,t.validations[r].verdict=d,t.validations[r].address=a.address,t.validations[r].validationStatus=Hl(d,t),t.validations[r].stagedAnswers=[],t.validations[r].attempt=t.validations[r].attempt+1,t.validations[r].originalAddress=pi$1(s);}),e.addCase(qe.rejected,(t,o)=>{let r=o.meta.arg.addressValidationId;t.validations[r].validationStatus=_e$1.VALIDATION_ERROR;}),e.addCase(Ot.fulfilled,(t,o)=>{t.validations[o.payload.addressValidationId].validationStatus=Yl(t,o.payload.addressValidationId),t.validations[o.payload.addressValidationId].verdict=null,t.validations[o.payload.addressValidationId].stagedAnswers=[];}),e.addMatcher(isAnyOf(...h),t=>t.validations?t:n({},Ro)),e.addMatcher(isAnyOf(...l),t=>n({},Ro));}}),Gl=e=>Dl(e.verdict)?ge$2.FIX:jl(e.verdict)&&!$l(e.address.addressComponents)?ge$2.CONFIRM:Wl(e.address.addressComponents)?ge$2.TYPO:ge$2.ACCEPT,Dl=e=>!e.addressComplete||e.hasUnconfirmedComponents,jl=e=>e.validationGranularity!=="OTHER"&&e.addressComplete&&(e.hasInferredComponents||e.hasReplacedComponents),Wl=e=>e.some(t=>t.spellCorrected),$l=e=>{let t=e.filter(r=>r.inferred);return !e.filter(r=>r.replaced).length&&t.length===1&&t[0].componentType==="postal_code_suffix"},Hl=(e,t)=>e===ge$2.ACCEPT?t.shouldOverrideValidationTrigger?_e$1.COMPLETED:_e$1.PROCEED_NEXT:_e$1.VALIDATED,Yl=(e,t)=>e.validations[t].attempt>=2?e.shouldOverrideValidationTrigger?_e$1.COMPLETED:_e$1.PROCEED_NEXT:_e$1.READY_TO_VALIDATE,{addAddressValidationAttempt:qv,initializeAddressValidation:Vv,resetAddressValidation:ks,resetAddressValidationAttempt:Mv,stageAddressValidationAnswer:ys,setAddressValidationStatus:Rs,setAddressValidationTriggerOverridden:Bv,hydrateAddressValidation:ws}=Qs.actions,Os=Qs;var bs=createListenerMiddleware();bs.startListening({matcher:isAnyOf(Rs,ys,ks,qe.fulfilled,qe.rejected),effect:(e,t)=>p(void 0,null,function*(){t.cancelActiveListeners();let o=t.getState();k(`bp-sdk-validation:${o.application.form.id}`,JSON.stringify(o.viewState.addressValidation.validations),{ttl:259200});})});var Es=bs;var Ts=[Es.middleware];var eu=[],tu=createSlice({name:"carriersProducts",initialState:eu,reducers:{},extraReducers:e=>{e.addCase(Q,(t,{payload:o})=>{let r=[...t];return o.events.forEach(i=>{i.event===xe$1.CarrierProducts&&y(i.data,t)&&(r=i.data);}),r}),e.addMatcher(isAnyOf(Rt,fe.fulfilled),(t,{payload:o})=>y(o,t)?o:t),e.addMatcher(isAnyOf(fe.pending,...l),()=>[]);}}),qs=tu;var Vs=n({},ta$1),su=createSlice({name:"choice",initialState:Vs,reducers:{},extraReducers:e=>{e.addCase(Ve.fulfilled,(t,o)=>{var s;let r=o.meta.arg,i=t[r.questionId];if(i&&i.timestamp>r.timestamp)return t;t[r.questionId]={list:(s=o.payload)!=null?s:[],timestamp:r.timestamp};}).addCase(q.fulfilled,(t,o)=>{var s;let r=o.meta.arg,i=t[r.questionId];if(i&&i.timestamp>r.timestamp)return t;t[r.questionId]={list:(s=o.payload.choices)!=null?s:[],timestamp:r.timestamp};}),e.addMatcher(isAnyOf(...l),t=>n({},Vs));}}),Ms=su;var du=[],cu=createSlice({name:"enrollments",initialState:du,reducers:{},extraReducers:e=>{e.addCase(me.fulfilled,(t,{payload:o})=>o.enrollments).addMatcher(isAnyOf(...l),()=>[]);}}),Bs=cu;var Gs=n({},Aa$1),Ut=(e,t)=>{e.meta.form.percent=t,t>e.meta.form.forwardProgressPercent&&(e.meta.form.forwardProgressPercent=t);},pu=createSlice({name:"progress",initialState:Gs,reducers:{},extraReducers:e=>{e.addCase(ee,(t,{payload:o})=>{Ut(t,o.percent_completed);}).addCase(yt,(t,{payload:o})=>{Ut(t,o.percent_completed);}).addCase(Q,(t,{payload:o})=>(o.events.forEach(r=>{switch(r.event){case xe$1.ApplicationForm:case xe$1.ApplicationFormPercentCompleted:Ut(t,r.data.percent_completed);break}}),t)),e.addMatcher(isAnyOf(...h),(t,{payload:o})=>{Ut(t,o.percent_completed);}).addMatcher(isAnyOf(...l),t=>n({},Gs));}}),Ds=pu;var Ws=n({},cs$1),Su=createSlice({name:"queues",initialState:Ws,reducers:{},extraReducers:e=>{e.addCase(Pe,(t,{payload:o})=>{let r=t.answers.queue.findIndex(i=>i.id===o.id);r===-1?t.answers.queue.push(o):t.answers.queue[r]=o;}).addCase(A.pending,(t,{meta:o})=>{if(!t.answers.outbound[o.arg.answer.id]){t.answers.outbound[o.arg.answer.id]=o.arg.answer;let r=t.answers.queue.findIndex(i=>i.id===o.arg.answer.id);r!==-1&&t.answers.queue.splice(r,1);}}).addCase(A.fulfilled,(t,{payload:o})=>{let r=t.answers.queue.find(i=>i.id===o.id);r&&(r.version=o.version);}),e.addMatcher(isAnyOf(A.fulfilled,A.rejected),(t,{meta:o})=>{t.answers.outbound[o.arg.answer.id]&&delete t.answers.outbound[o.arg.answer.id];}).addMatcher(isAnyOf(...l),()=>n({},Ws));}}),$s=Su;var Hs=n({},Ca),hu=createSlice({name:"quoteBind",initialState:Hs,reducers:{},extraReducers:e=>{e.addCase(Ne.fulfilled,(t,{payload:o,meta:r})=>{let{retrieve_url:i}=o;t[r.arg.quoteId]=i;}),e.addMatcher(isAnyOf(...l),t=>n({},Hs));}}),Ys=hu;var zs=n({},wa$1),wu=createSlice({name:"refilters",initialState:zs,reducers:{},extraReducers:e=>{e.addCase(q.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=t[i.questionId];if(s&&s.timestamp>i.timestamp)return t;t[i.questionId]={list:(a=o==null?void 0:o.refilter)!=null?a:[],timestamp:i.timestamp};}),e.addMatcher(isAnyOf(...l),t=>n({},zs));}}),Ks=wu;var Pu={},Qu=createSlice({name:"status/remote/vehicles/configurations",initialState:Pu,reducers:{},extraReducers:e=>{e.addCase(Ue.pending,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.NotLoaded;}).addCase(b.fulfilled,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loaded;}).addCase(Ue.rejected,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Error;}),e.addMatcher(isAnyOf(x.pending,g.pending,f.pending,S.pending,x.rejected,x.fulfilled,g.rejected,g.fulfilled,f.rejected,f.fulfilled,S.rejected,S.fulfilled),(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.NotLoaded;}).addMatcher(isAnyOf(...l),t=>({}));}}),Xs=Qu;var yu={},Ru=createSlice({name:"status/remote/vehicles/makes",initialState:yu,reducers:{},extraReducers:e=>{e.addCase(g.pending,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loading;}).addCase(g.fulfilled,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loaded;}).addCase(g.rejected,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Error;}),e.addMatcher(isAnyOf(f.pending,S.pending,f.rejected,f.fulfilled,S.rejected,S.fulfilled),(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.NotLoaded;}).addMatcher(isAnyOf(...l),t=>({}));}}),en=Ru;var bu={},Eu=createSlice({name:"status/remote/vehicles/models",initialState:bu,reducers:{},extraReducers:e=>{e.addCase(x.pending,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loading;}).addCase(x.fulfilled,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loaded;}).addCase(x.rejected,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Error;}),e.addMatcher(isAnyOf(f.pending,f.rejected,f.fulfilled,g.pending,g.rejected,g.fulfilled,S.pending,S.rejected,S.fulfilled),(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.NotLoaded;}).addMatcher(isAnyOf(...l),t=>({}));}}),on=Eu;var Fu={},qu=createSlice({name:"status/remote/vehicles/selections",initialState:Fu,reducers:{},extraReducers:e=>{e.addCase(Ft.pending,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loading;}).addCase(Ft.fulfilled,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loaded;}).addCase(Ft.rejected,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Error;}).addCase(rr,(t,{payload:o})=>{t[o.questionGroupId]=R$1.NotLoaded;}),e.addMatcher(isAnyOf(...l),t=>({}));}}),rn=qu;var Mu={},Bu=createSlice({name:"status/remote/vehicles/vins",initialState:Mu,reducers:{},extraReducers:e=>{e.addCase(S.pending,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loading;}).addCase(S.fulfilled,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loaded;}).addCase(S.rejected,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Error;}),e.addMatcher(isAnyOf(f.pending,f.rejected,f.fulfilled,g.pending,g.rejected,g.fulfilled,x.pending,x.rejected,x.fulfilled),(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.NotLoaded;}).addMatcher(isAnyOf(...l),t=>({}));}}),nn=Bu;var Uu={},Gu=createSlice({name:"status/remote/vehicles/years",initialState:Uu,reducers:{},extraReducers:e=>{e.addCase(f.pending,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loading;}).addCase(f.fulfilled,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Loaded;}).addCase(f.rejected,(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.Error;}),e.addMatcher(isAnyOf(S.pending,S.rejected,S.fulfilled),(t,{meta:o})=>{t[o.arg.questionGroupId]=R$1.NotLoaded;}).addMatcher(isAnyOf(...l),t=>({}));}}),dn=Gu;var cn=combineReducers({configurations:Xs.reducer,makes:en.reducer,models:on.reducer,selection:rn.reducer,vins:nn.reducer,years:dn.reducer});var ln=n({},I$1),Hu=createSlice({name:"status/remote/answers",initialState:ln,reducers:{},extraReducers:e=>{e.addCase(A.pending,(t,{meta:o})=>lr$1(t,o.arg.answer.id,R$1.Loading)).addCase(A.fulfilled,(t,{meta:o})=>lr$1(t,o.arg.answer.id,R$1.Loaded)).addCase(A.rejected,(t,{meta:o})=>lr$1(t,o.arg.answer.id,R$1.Error)),e.addMatcher(isAnyOf(...l),t=>n({},ln));}}),un=Hu;var Ku=n({},Se$2),Ju=createSlice({name:"status/remote/applicationForm",initialState:Ku,reducers:{},extraReducers:e=>{e.addMatcher(isAnyOf(...po),t=>{t.form=R$1.NotLoaded;}).addMatcher(isAnyOf(...br,Pt.pending),t=>{t.form=R$1.Loading;}).addMatcher(isAnyOf(...h,Pt.fulfilled),t=>{t.form=R$1.Loaded;}).addMatcher(isAnyOf(...Qt,Pt.rejected),t=>{t.form=R$1.Error;});}}),pn=Ju;var ep={},tp=createSlice({name:"status/remote/bindQuotes",initialState:ep,reducers:{},extraReducers:e=>{e.addCase(Ne.pending,(t,{meta:o})=>{t[o.arg.quoteId]=R$1.Loading;}).addCase(Ne.fulfilled,(t,{meta:o})=>{t[o.arg.quoteId]=R$1.Loaded;}).addCase(Ne.rejected,(t,{meta:o})=>{t[o.arg.quoteId]=R$1.Error;}).addCase(Lt.pending,(t,{meta:o})=>{t[o.arg.quote.id]=R$1.Loading;}).addCase(Lt.fulfilled,(t,{meta:o})=>{t[o.arg.quote.id]=R$1.Loaded;}).addCase(Lt.rejected,(t,{meta:o})=>{t[o.arg.quote.id]=R$1.Error;}),e.addMatcher(isAnyOf(...l),t=>({}));}}),mn=tp;var fn=n({},D),sp=createSlice({name:"status/remote/carriersProducts",initialState:fn,reducers:{},extraReducers:e=>{e.addCase(fe.pending,t=>{t.state=R$1.Loading;}).addCase(fe.fulfilled,t=>{t.state=R$1.Loaded;}).addCase(fe.rejected,t=>{t.state=R$1.Error;}),e.addMatcher(isAnyOf(...l),t=>n({},fn));}}),Sn=sp;var dp={},cp=createSlice({name:"status/remote/choices",initialState:dp,reducers:{},extraReducers:e=>{e.addCase(q.pending,(t,{meta:o})=>{t[o.arg.questionId]=R$1.Loading;}).addCase(q.fulfilled,(t,{meta:o})=>{t[o.arg.questionId]=R$1.Loaded;}).addCase(q.rejected,(t,{meta:o})=>{t[o.arg.questionId]=R$1.Error;}),e.addMatcher(isAnyOf(...l),t=>({}));}}),gn=cp;var An=n({},I$1),mp=createSlice({name:"status/remote/questionPool",initialState:An,reducers:{},extraReducers:e=>{e.addCase(Et.pending,(t,{meta:o})=>lr$1(t,o.arg.question_pool_id,R$1.Loading)).addCase(Et.fulfilled,(t,{meta:o})=>lr$1(t,o.arg.question_pool_id,R$1.Loaded)).addCase(Et.rejected,(t,{meta:o})=>lr$1(t,o.arg.question_pool_id,R$1.Error)).addCase(Tt.pending,(t,{meta:o})=>lr$1(t,o.arg.answer_pool_id,R$1.Loading)).addCase(Tt.fulfilled,(t,{meta:o})=>lr$1(t,o.arg.answer_pool_id,R$1.Loaded)).addCase(Tt.rejected,(t,{meta:o})=>lr$1(t,o.arg.answer_pool_id,R$1.Error)),e.addMatcher(isAnyOf(...l),t=>n({},An));}}),In=mp;var hn=n({},I$1),Ap=createSlice({name:"status/remote/questionSets",initialState:hn,reducers:{},extraReducers:e=>{e.addCase(Me.pending,(t,{meta:o})=>lr$1(t,o.arg.id,R$1.Loading)).addCase(Me.fulfilled,(t,{meta:o})=>lr$1(t,o.arg.id,R$1.Loaded)).addCase(Me.rejected,(t,{meta:o})=>lr$1(t,o.arg.id,R$1.Error)),e.addCase(Be.pending,(t,{meta:o})=>lr$1(t,o.arg.appFormQuestionSet.id,R$1.Loading)).addCase(Be.fulfilled,(t,{meta:o})=>lr$1(t,o.arg.appFormQuestionSet.id,R$1.Loaded)).addCase(Be.rejected,(t,{meta:o})=>lr$1(t,o.arg.appFormQuestionSet.id,R$1.Error)),e.addMatcher(isAnyOf(...l),t=>n({},hn));}}),_n=Ap;var Cn=n({},O$1),_p=createSlice({name:"viewState/Features",initialState:Cn,reducers:{},extraReducers:e=>{e.addCase(bt.pending,t=>{t.isLoaded=!1,t.status=u$1.Loading;}).addCase(bt.fulfilled,(t,{payload:o})=>{t.list=o,t.isLoaded=!0,t.status=u$1.Loaded;}).addCase(bt.rejected,t=>{t.isLoaded=!1,t.status=u$1.Error;}).addCase(K,t=>n({},Cn));}}),xn=_p;var wn=n({},N$1),vn=createSlice({name:"viewState/Quotes",initialState:wn,reducers:{setFilteredOnlineQuotes:(e,{payload:t})=>{e.filteredOnlineQuotes=t;},setFilteredOfflineQuotes:(e,{payload:t})=>{e.filteredOfflineQuotes=t;}},extraReducers:e=>{e.addMatcher(isAnyOf(...l),t=>n({},wn));}}),{setFilteredOfflineQuotes:Uk,setFilteredOnlineQuotes:Gk}=vn.actions,Pn=vn;var Pp={},Qp=createSlice({name:"viewState/vehicleOptions/Configurations",initialState:Pp,reducers:{},extraReducers:e=>{e.addCase(b.fulfilled,(t,{payload:o,meta:r})=>{let i=r.arg,s=ni(o);t[i.questionGroupId]=ti(s);}).addCase(Ue.fulfilled,(t,{payload:o,meta:r})=>{t[r.arg.questionGroupId]=ti(o);}).addCase(W.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o==null?void 0:o.configurations)!=null?a:[];t[i.questionGroupId]=ti(s);}).addCase(S.fulfilled,(t,{payload:o,meta:r})=>{let i=o,s=i==null?void 0:i.parsedBody;if(!o)return t;let a=ni(s);t[r.arg.questionGroupId]=a.reduce((d,u)=>c(n({},d),{[u.id]:u.name}),{});}),e.addMatcher(isAnyOf(Ue.pending,x.pending,g.pending,f.pending,S.pending,x.fulfilled,g.fulfilled,f.fulfilled,x.rejected,g.rejected,f.rejected,S.rejected),(t,{meta:o})=>{let r=o.arg;t[r.questionGroupId]={};}).addMatcher(isAnyOf(...l),t=>({}));}}),yn=Qp;var yp={},Rp=createSlice({name:"viewState/vehicleOptions/Makes",initialState:yp,reducers:{},extraReducers:e=>{e.addCase(b.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o.makes)!=null?a:[];t[i.questionGroupId]=zo(s);}).addCase(g.fulfilled,(t,{payload:o,meta:r})=>{let i=r.arg,s=o!=null?o:[];t[i.questionGroupId]=zo(s);}).addCase(W.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o==null?void 0:o.makes)!=null?a:[];t[i.questionGroupId]=zo(s);}),e.addMatcher(isAnyOf(g.rejected,f.pending,S.pending,f.fulfilled,S.rejected,S.fulfilled),(t,{meta:o})=>{let r=o.arg;t[r.questionGroupId]={};}).addMatcher(isAnyOf(...l),t=>({}));}}),On=Rp;var bp={},Ep=createSlice({name:"viewState/vehicleOptions/Models",initialState:bp,reducers:{},extraReducers:e=>{e.addCase(b.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o.models)!=null?a:[];t[i.questionGroupId]=ei$1(s);}).addCase(x.fulfilled,(t,{payload:o,meta:r})=>{let i=r.arg,s=o!=null?o:[];t[i.questionGroupId]=ei$1(s);}).addCase(W.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o==null?void 0:o.models)!=null?a:[];t[i.questionGroupId]=ei$1(s);}),e.addMatcher(isAnyOf(g.rejected,g.fulfilled,f.rejected,f.fulfilled,S.rejected,S.fulfilled),(t,{meta:o})=>{let r=o.arg;t[r.questionGroupId]={};}).addMatcher(isAnyOf(...l),t=>({}));}}),En=Ep;var Fp={},Tn=createSlice({name:"viewState/vehicleOptions/Selection",initialState:Fp,reducers:{setVehicleSelection:(e,{payload:t})=>{e[t.questionGroupId]=n(n({},e[t.questionGroupId]),t.selection);}},extraReducers:e=>{e.addCase(W.fulfilled,(t,{payload:o,meta:r})=>{let i=r.arg,{yearId:s,makeId:a,modelId:d,configurationId:u}=o;t[i.questionGroupId]=c(n({},t[i.questionGroupId]),{yearId:s,makeId:a,modelId:d,configurationId:u});}),e.addMatcher(isAnyOf(...l),t=>({}));}}),{setVehicleSelection:uy}=Tn.actions,Ln=Tn;var qn=3,Mp={},Bp=createSlice({name:"viewState/vehicleOptions/Vin",initialState:Mp,reducers:{},extraReducers:e=>{e.addCase(S.fulfilled,(t,{payload:o,meta:r})=>{var m;let i=o,s=i==null?void 0:i.parsedBody,a=r.arg;if(!s)return t;let d=ni(s),u=(m=t[a.questionGroupId])!=null?m:n({},Oa$1);if(d.length===0){let I=u.errorCount+1;return t[a.questionGroupId]=c(n({},u),{errorCount:I,isAvailable:I<qn,lastResponse:i}),t}t[a.questionGroupId]=c(n({},u),{errorCount:0,isAvailable:!0,lastResponse:void 0});}).addCase(S.rejected,(t,{meta:o})=>{var a;let r=o.arg,i=(a=t[r.questionGroupId])!=null?a:n({},Oa$1),s=i.errorCount+1;t[r.questionGroupId]=c(n({},i),{errorCount:s,isAvailable:s<qn,lastResponse:void 0});}),e.addMatcher(isAnyOf(b.pending,x.pending,g.pending,f.pending,b.rejected,b.fulfilled,x.rejected,x.fulfilled,g.rejected,g.fulfilled,f.rejected,f.fulfilled),(t,{meta:o})=>{let r=o.arg;t[r.questionGroupId]=n({},Oa$1);}).addMatcher(isAnyOf(...l),t=>({}));}}),Vn=Bp;var Up={},Gp=createSlice({name:"viewState/vehicleOptions/Years",initialState:Up,reducers:{},extraReducers:e=>{e.addCase(b.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o.years)!=null?a:[];t[i.questionGroupId]=Ho$1(s);}).addCase(f.fulfilled,(t,{payload:o,meta:r})=>{let i=r.arg,s=o!=null?o:[];t[i.questionGroupId]=Ho$1(s);}).addCase(W.fulfilled,(t,{payload:o,meta:r})=>{var a;let i=r.arg,s=(a=o==null?void 0:o.years)!=null?a:[];t[i.questionGroupId]=Ho$1(s);}),e.addMatcher(isAnyOf(f.pending),(t,{meta:o})=>{let r=o.arg;t[r.questionGroupId]={};}).addMatcher(isAnyOf(...l),t=>({}));}}),Bn=Gp;var Un=combineReducers({vehicleOptions:combineReducers({configurations:yn.reducer,makes:On.reducer,models:En.reducer,selection:Ln.reducer,vin:Vn.reducer,years:Bn.reducer}),features:xn.reducer,quotes:Pn.reducer,addressValidation:Os.reducer});var Dn=n({},D),$p=createSlice({name:"status/remote/quotes",initialState:Dn,reducers:{},extraReducers:e=>{e.addCase(ee,(t,{payload:o})=>jn(t,o)).addCase(er,(t,{payload:o})=>{t.state=R$1.Loaded,t.updated_at=o.updatedAt;}).addCase(Q,(t,{payload:o})=>{o.events.forEach(r=>{if(r.event===xe$1.ApplicationForm)return jn(t,r.data)});}),e.addMatcher(isAnyOf(...l),t=>n({},Dn)).addMatcher(isAnyOf(...h),(t,{payload:o})=>{t.state=$n(o);}).addMatcher(isAnyOf(...Qt),t=>{t.state=R$1.Error;});}}),Wn=$p,$n=e=>{let t=R$1.NotLoaded;return e.state===x$3.Completed&&!e.taken_over&&!e.cloned?t=e.quote_requests_count===0?R$1.Loaded:R$1.Loading:e.state===x$3.Quoted&&(t=e.finished_quote_requests_count===e.quote_requests_count?R$1.Loaded:R$1.Loading),t},jn=(e,t)=>{let o=new Date(e.updated_at||0),r=new Date(t.updated_at);return r>o&&(e.state=$n(t),e.updated_at=r),e};var Yp={},zp=createSlice({name:"status/remote/refilters",initialState:Yp,reducers:{},extraReducers:e=>{e.addMatcher(isAnyOf(Ve.pending,q.pending),(t,{meta:o})=>{t[o.arg.questionId]=R$1.Loading;}).addMatcher(isAnyOf(Ve.fulfilled,q.fulfilled),(t,{meta:o})=>{t[o.arg.questionId]=R$1.Loaded;}).addMatcher(isAnyOf(Ve.rejected,q.rejected),(t,{meta:o})=>{t[o.arg.questionId]=R$1.Error;}).addMatcher(isAnyOf(...l),t=>({}));}}),Hn=zp;var Yn=combineReducers({vehicles:cn,answers:un.reducer,application:pn.reducer,bindQuotes:mn.reducer,carriersProducts:Sn.reducer,choices:gn.reducer,questionPools:In.reducer,questionSets:_n.reducer,quotes:Wn.reducer,refilters:Hn.reducer});var Xp=[],Zp=createSlice({name:"siblingQuote",initialState:Xp,reducers:{},extraReducers:e=>{e.addMatcher(isAnyOf(...h),(t,{payload:o})=>{if(o!=null&&o.sibling_quote_requests){let r=[];return r=o.sibling_quote_requests.reduce((i,s)=>em(i,s),r),r}return t}).addMatcher(isAnyOf(...l),t=>[]);}}),Kn=Zp,em=(e,t)=>{var a;let o=[...e],s=t,i=pt(s,["quotes"]);return o.push(...((a=t.quotes)!=null?a:[]).map(d=>c(n(n({},i),d),{id:`${t.id}${d.supplier_code?`-${d.supplier_code}`:""}`,parentQuoteRequestId:t.id}))),o};var om=combineReducers({form:Gr.reducer,enrollments:Bs.reducer,choices:Ms.reducer,errors:As.reducer,pendingProcesses:Xr.reducer,progress:Ds.reducer,questionSets:Di.reducer,quotes:Yi.reducer,siblingQuotes:Kn.reducer,quoteBind:Ys.reducer,carriersProducts:qs.reducer,refilters:Ks.reducer}),rm=combineReducers({remote:Yn,local:ls.reducer}),Jn="production",Xn=configureStore({reducer:{application:om,auth:rs.reducer,queues:$s.reducer,config:as.reducer,notifications:$r.reducer,viewState:Un,status:rm},middleware:e=>e({thunk:!0,immutableCheck:Jn!=="production",serializableCheck:Jn!=="production"}).prepend(Ts).concat(vs),devTools:{name:`Bold Penguin SDK Store - ${Date.now()}`}}),fO=()=>{var e,t,o,r;return window&&!((e=window.BpSdk)!=null&&e.store)&&(window.BpSdk=c(n({},(t=window.BpSdk)!=null?t:{}),{store:Xn})),(r=(o=window==null?void 0:window.BpSdk)==null?void 0:o.store)!=null?r:n({},Xn)};

export { $, dx as A, Be as B, rx as C, DS as D, E, Fg as F, io as G, H, Ih as I, Jm as J, jf as K, Df as L, Mg as M, Nf as N, O, Pt as P, Ne as Q, R, er as S, T, Lt as U, Vm as V, Uk as W, XA as X, Gk as Y, ne as Z, et as _, Eg as a, Ot as a$, Of as a0, Kg as a1, S$1 as a2, sw as a3, M as a4, hS as a5, lr as a6, ae as a7, Tg as a8, lm as a9, Ft as aA, rr as aB, b as aC, uy as aD, W as aE, ld as aF, bA as aG, wA as aH, vA as aI, Hg as aJ, ud as aK, fd as aL, pd as aM, S as aN, md as aO, Sd as aP, EA as aQ, YA as aR, KA as aS, jA as aT, UA as aU, BA as aV, Mm as aW, zA as aX, JA as aY, Mv as aZ, Zh as a_, bt as aa, pA as ab, G_ as ac, Fm as ad, eg as ae, rt as af, SS as ag, AS as ah, Hf as ai, WA as aj, Wf as ak, $f as al, NA as am, GA as an, MA as ao, jm as ap, ZA as aq, Vv as ar, ks as as, Tt as at, f as au, g as av, x as aw, Ue as ax, Me as ay, ot as az, T$1 as b, ys as b0, A as b1, qe as b2, Et as b3, Ve as b4, Tf as b5, q as b6, Wm as b7, Uf as b8, Gf as b9, F as c, b$1 as d, q$1 as e, fO as f, of as g, RS as h, gt as i, jg as j, Or as k, Rs as l, mr as m, Bv as n, ox as o, se as p, qw as q, qS as r, sx as s, jS as t, HA as u, v$1 as v, w$1 as w, DA as x, $A as y, ix as z };
